import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Map: unknown;
  Time: string;
  TimeStamp: string;
};

export type Acceptance = {
  readonly __typename?: 'Acceptance';
  readonly ageRestriction: AgeRestriction;
  readonly class: Scalars['String'];
  readonly date: Scalars['TimeStamp'];
  readonly distance: Scalars['Int'];
  readonly gbsMeetingId: Scalars['String'];
  readonly jockey: Scalars['String'];
  readonly jockeyGlobalId: Scalars['ID'];
  readonly prizeTotal: Scalars['Int'];
  readonly raceName: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly runner: Scalars['String'];
  readonly runnerGlobalId: Scalars['ID'];
  readonly sexRestriction: SexRestriction;
  readonly startTime: Scalars['TimeStamp'];
  readonly track: Scalars['String'];
  readonly trainer: Scalars['String'];
  readonly trainerGlobalId: Scalars['ID'];
};

export type ActiveRunnerRule4 = {
  readonly __typename?: 'ActiveRunnerRule4';
  readonly Name: Scalars['String'];
  readonly Number: Scalars['Int'];
  readonly Price: Scalars['Float'];
};

export type AgeRestriction = {
  readonly __typename?: 'AgeRestriction';
  readonly maximumAgeInclusive: Scalars['Int'];
  readonly minimumAgeInclusive: Scalars['Int'];
};

export type BetFairLevel = {
  readonly __typename?: 'BetFairLevel';
  readonly level: Scalars['Int'];
  readonly price: Scalars['Float'];
  readonly volume: Scalars['Float'];
};

export type BetFairMarket = {
  readonly __typename?: 'BetFairMarket';
  readonly id: Scalars['String'];
  readonly isClosed: Scalars['Boolean'];
  readonly meetingId: Scalars['ID'];
  readonly priceType: BetFairPriceType;
  readonly raceNumber: Scalars['Int'];
  readonly selections?: Maybe<ReadonlyArray<BetFairSelection>>;
  readonly totalTraded?: Maybe<Scalars['Float']>;
};

export enum BetFairPriceType {
  Place = 'PLACE',
  Win = 'WIN'
}

export type BetFairSelection = {
  readonly __typename?: 'BetFairSelection';
  readonly availableToBack?: Maybe<ReadonlyArray<BetFairLevel>>;
  readonly availableToLay?: Maybe<ReadonlyArray<BetFairLevel>>;
  readonly couplingCode?: Maybe<Scalars['String']>;
  readonly isScratched?: Maybe<Scalars['Boolean']>;
  readonly lastTradedFlucs?: Maybe<ReadonlyArray<PriceFluc>>;
  readonly lastTradedPrice?: Maybe<Scalars['Float']>;
  readonly marketId: Scalars['String'];
  readonly name: Scalars['String'];
  readonly number: Scalars['Int'];
  readonly selectionId: Scalars['Int'];
  /** Selling Price Near */
  readonly sellingPrice?: Maybe<Scalars['Float']>;
  readonly sellingPriceTraded?: Maybe<Scalars['Float']>;
  readonly totalTraded?: Maybe<Scalars['Float']>;
};

export enum BetType {
  All = 'ALL',
  Big6 = 'BIG6',
  DailyDouble = 'DAILY_DOUBLE',
  EarlyQuadrella = 'EARLY_QUADRELLA',
  Exacta = 'EXACTA',
  ExtraDouble = 'EXTRA_DOUBLE',
  FeatureDouble = 'FEATURE_DOUBLE',
  FirstFour = 'FIRST_FOUR',
  Omni = 'OMNI',
  OpeningFluc = 'OPENING_FLUC',
  Pentafecta = 'PENTAFECTA',
  Pick3 = 'PICK3',
  Pick4 = 'PICK4',
  Pick5 = 'PICK5',
  Pick6 = 'PICK6',
  Pick7 = 'PICK7',
  Pick8 = 'PICK8',
  Pick9 = 'PICK9',
  Pick10 = 'PICK10',
  PickX = 'PICK_X',
  Place = 'PLACE',
  Place_2 = 'PLACE_2',
  PlaceFixedOdds = 'PLACE_FIXED_ODDS',
  PlaceFixedOdds2 = 'PLACE_FIXED_ODDS2',
  Quadrella = 'QUADRELLA',
  Quinella = 'QUINELLA',
  QuinellaFixedOdds = 'QUINELLA_FIXED_ODDS',
  QuinellaPlace = 'QUINELLA_PLACE',
  RunningDouble = 'RUNNING_DOUBLE',
  SixUp = 'SIX_UP',
  SpecialDouble = 'SPECIAL_DOUBLE',
  StartingPrice = 'STARTING_PRICE',
  Superfecta = 'SUPERFECTA',
  TopFluc = 'TOP_FLUC',
  Treble = 'TREBLE',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  VPick = 'V_PICK',
  Win = 'WIN',
  WinFixedOdds = 'WIN_FIXED_ODDS'
}

export type Career = {
  readonly __typename?: 'Career';
  readonly all?: Maybe<PlacingStats>;
  readonly detail?: Maybe<Detail>;
  readonly spell?: Maybe<Spell>;
  readonly summary?: Maybe<Summary>;
};

export type Comment = {
  readonly __typename?: 'Comment';
  readonly comment: Scalars['String'];
  readonly source: Scalars['String'];
};

/** Contains a payload of new comments for a race, including both general race analysis and specific competitor insights. */
export type CommentUpdate = {
  readonly __typename?: 'CommentUpdate';
  /** A list of new comments, grouped by the specific competitor they refer to. */
  readonly competitorComments: ReadonlyArray<CompetitorComment>;
  /** A list of new comments that pertain to the race as a whole. */
  readonly raceComments: ReadonlyArray<Comment>;
  /** The id of the race to which these comments apply. */
  readonly raceId: Scalars['ID'];
};

/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type Competitor = {
  readonly __typename?: 'Competitor';
  /** The age of the competitor in years. */
  readonly age: Scalars['Int'];
  /** The weight reduction (in kilograms) applied because the horse is ridden by an apprentice jockey. Returns 0 if the jockey is not an apprentice. */
  readonly allowanceWeight?: Maybe<Scalars['Float']>;
  /** A boolean flag that is `true` if the jockey is an apprentice, which typically entitles the horse to a weight allowance. */
  readonly apprenticeIndicator: Scalars['Boolean'];
  /** The competitor’s starting barrier, gate, or box number. */
  readonly barrier: Scalars['Int'];
  /** The best time recorded by the competitor for the race distance. Only for Greyhounds. */
  readonly bestTime: Scalars['String'];
  /** Indicates if the competitor is wearing blinkers. */
  readonly blinkers: Scalars['String'];
  /** The coat color of the competitor, returned as a standard abbreviation. Common values include 'b' (Bay), 'bl' (Black), 'ch' (Chestnut), 'b/br' (Bay or Brown), and 'gr/ro' (Grey or Roan). */
  readonly colour: Scalars['String'];
  /** @deprecated comment is deprecated, use comments(source) instead */
  readonly comment: Scalars['String'];
  /** Analyst observations on how the competitor may perform in this race, filterable by language and source. */
  readonly comments: ReadonlyArray<SourceComment>;
  /** The country where the competitor was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** A shared ID for two or more competitors “coupled” together as a single betting interest. This has limited jurisdictional coverage (e.g., USA). */
  readonly coupledRunnerId: Scalars['String'];
  /** Indicates if the competitor is a previous winner at the course (C), distance (D), or both (CD). */
  readonly courseDistanceWinner: Scalars['String'];
  /** The timestamp when the competitor was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The name of the competitor's mother (dam). */
  readonly dam: Scalars['String'];
  /** The country where the dam was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly damCountry: Scalars['String'];
  /** The name of the father of the competitor's dam. */
  readonly damSire: Scalars['String'];
  /** The number of days that have passed since the competitor’s most recent race. */
  readonly daysSinceLastRun?: Maybe<Scalars['Int']>;
  /** Indicates if the competitor is an emergency entrant for the race. */
  readonly emergencyIndicator: Scalars['Boolean'];
  /** Indicates if the competitor failed to finish their last race. */
  readonly failedToFinish: Scalars['Boolean'];
  /** The reason the competitor failed to finish, if applicable. */
  readonly failedToFinishReason: Scalars['String'];
  /** The official final finishing position of the competitor in the race. */
  readonly finalPosition?: Maybe<Scalars['Int']>;
  /** A history of the competitor's price fluctuations from a specific source and for a given price type. */
  readonly flucs: ReadonlyArray<PriceFluc>;
  /** The date the competitor was born (foaled). */
  readonly foalingDate?: Maybe<Scalars['TimeStamp']>;
  /** A history of the competitor's previous race performances. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  /** A description of any gear worn by the competitor for this race. */
  readonly gearChangesDescription: Scalars['String'];
  /** Prices generated by Betmakers' PriceManager product for this competitor. */
  readonly generatedPrice: ReadonlyArray<Price>;
  /** The competitor's positions at various points during the race, filterable by `source`. */
  readonly inRun: ReadonlyArray<InRun>;
  /** The name of the jockey (for THOROUGHBREDS) or driver (for HARNESS). */
  readonly jockey: Scalars['String'];
  /** The unique internal identifier for the jockey or driver. */
  readonly jockeyID: Scalars['ID'];
  /** Statistics for the jockey. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly jockeyStatistics?: Maybe<Statistics>;
  /** The time of a late scratching, if applicable. */
  readonly lateScratchingTime?: Maybe<Scalars['TimeStamp']>;
  /** The finishing margin in lengths between this competitor and the winner. Winner is set to 0. */
  readonly margin?: Maybe<Scalars['Float']>;
  /** Information on any medication the competitor has been administered. */
  readonly medication: Scalars['String'];
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /** The name(s) of the competitor's owners. */
  readonly owners: Scalars['String'];
  /** Performance ratings for the competitor. Note: This field is not available in `MeetingsDated` or `Races` queries and will return empty. */
  readonly performanceRatings: ReadonlyArray<PerformanceRating>;
  /** The predicted performance rating for the competitor in this race. Permission required. */
  readonly predictedRating: PredictedRating;
  /** A list of current betting prices for the competitor, filterable by source. */
  readonly prices: ReadonlyArray<Price>;
  /** The total prize money earned by the competitor throughout its entire career. */
  readonly prizeMoney: Scalars['Int'];
  /** A link back to the race this competitor is a part of. */
  readonly race: Race;
  /** The competitor's RACELAB insights, providing performance analytics. */
  readonly racelabInsights: RacelabInsights;
  /** The competitor's overall performance rating. Note: This field is not available in `MeetingsDated` or `Races` queries and will return empty. */
  readonly rating: Rating;
  /** The results for this competitor in the race, filterable by source and optionally including interim results. */
  readonly results: ReadonlyArray<ResultPosition>;
  /** The starting row for the competitor, for Harness racing. */
  readonly row: Scalars['String'];
  /** The runner entity associated with this competitor. */
  readonly runner: Runner;
  /** Statistics for the runner. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly runnerStatistics?: Maybe<Statistics>;
  /** @deprecated scratched is deprecated, use scratchingType instead */
  readonly scratched: Scalars['Boolean'];
  /** The scratching status of the competitor (e.g., STARTER, SCRATCHED). */
  readonly scratchingType: ScratchingType;
  /** The external ID for this competitor from a specific data source. */
  readonly selectionID: Scalars['String'];
  /** The sex of the competitor (e.g., Colt, Filly, Gelding). */
  readonly sex: CompetitorSex;
  /** A description of the colors and pattern of the jockey's silks. */
  readonly silksColour: Scalars['String'];
  /** A URL to an image of the jockey's silks. Available sizes: 20, 24, 32, 64, 128, 512. */
  readonly silksURL: Scalars['String'];
  /** The name of the competitor's father (sire). */
  readonly sire: Scalars['String'];
  /** The country where the sire was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly sireCountry: Scalars['String'];
  /** A human-readable description of the competitor's predicted running position in the early stages of the race, based on speedmap analysis. Common values include 'LEAD', 'HANDY', 'MID', or combinations like 'LEAD/HANDY'. An empty string may indicate a backmarker or insufficient data. */
  readonly speedmapPosition?: Maybe<Scalars['String']>;
  /** A numerical score used to generate the speedmap position. A lower value indicates a position closer to the front of the race. For example, 1 often corresponds to a 'LEAD' position, while higher numbers indicate midfield or backmarker running styles. */
  readonly speedmapValue: Scalars['Float'];
  /** For standing start (SS) harness races, this is the handicap in meters, indicating how far back from the start tape the competitor begins. */
  readonly startingHandicap?: Maybe<Scalars['Int']>;
  /** The runner number assigned to the competitor. */
  readonly tabNo: Scalars['Int'];
  /** The name of the competitor's trainer. */
  readonly trainer: Scalars['String'];
  /** The unique internal identifier for the trainer. */
  readonly trainerID: Scalars['ID'];
  /** Statistics for the trainer. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly trainerStatistics?: Maybe<Statistics>;
  /** The location where the competitor is trained. */
  readonly trainingLocation: Scalars['String'];
  /** The timestamp of the last update to this competitor's information. */
  readonly updated: Scalars['TimeStamp'];
  /**   */
  readonly weightAllocated: Scalars['Float'];
  /**   */
  readonly weightTotal: Scalars['Float'];
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorCommentsArgs = {
  languages?: InputMaybe<ReadonlyArray<Language>>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorCoupledRunnerIdArgs = {
  source: Scalars['String'];
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorFlucsArgs = {
  priceType?: InputMaybe<PriceType>;
  source: Scalars['String'];
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorFormHistoryArgs = {
  maxRuns?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorInRunArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorJockeyStatisticsArgs = {
  source?: InputMaybe<Scalars['String']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorPerformanceRatingsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorPricesArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorResultsArgs = {
  includeInterim?: InputMaybe<Scalars['Boolean']>;
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorRunnerStatisticsArgs = {
  source?: InputMaybe<Scalars['String']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorSelectionIdArgs = {
  source: Scalars['String'];
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorSilksUrlArgs = {
  size: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
  sprite?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a single competitor (e.g., a horse) in a race, containing all of its relevant details, statistics, and race-specific information. */
export type CompetitorTrainerStatisticsArgs = {
  source?: InputMaybe<Scalars['String']>;
};

export type CompetitorComment = {
  readonly __typename?: 'CompetitorComment';
  readonly comments: ReadonlyArray<Comment>;
  readonly name: Scalars['String'];
  readonly runnerNumber: Scalars['Int'];
};

export enum CompetitorSex {
  B = 'B',
  C = 'C',
  D = 'D',
  F = 'F',
  G = 'G',
  H = 'H',
  M = 'M',
  R = 'R',
  U = 'U'
}

/** Contains a payload of real-time updates for a single competitor. */
export type CompetitorUpdate = {
  readonly __typename?: 'CompetitorUpdate';
  /** The age of the competitor in years. */
  readonly age: Scalars['Int'];
  /** The weight reduction (in kilograms) if the horse is ridden by an apprentice jockey. */
  readonly allowanceWeight?: Maybe<Scalars['Float']>;
  /** A boolean flag that is `true` if the jockey is an apprentice. */
  readonly apprenticeIndicator: Scalars['Boolean'];
  /** The starting barrier, gate, or box number for the competitor. */
  readonly barrier: Scalars['Int'];
  /** The country where the competitor was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** The timestamp when the competitor was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** A flag indicating if the competitor is an emergency entrant. */
  readonly emergencyIndicator: Scalars['Boolean'];
  /** A flag indicating if the competitor failed to finish the current race. */
  readonly failedToFinish: Scalars['Boolean'];
  /** The reason the competitor failed to finish, if applicable. */
  readonly failedToFinishReason: Scalars['String'];
  /** The official final finishing position of the competitor. */
  readonly finalPosition?: Maybe<Scalars['Int']>;
  /** A description of any gear changes for this race. */
  readonly gearChangesDescription: Scalars['String'];
  /** The name of the jockey (for THOROUGHBREDS) or driver (for HARNESS). */
  readonly jockey: Scalars['String'];
  /** The unique internal identifier for the jockey or driver. */
  readonly jockeyID: Scalars['ID'];
  /** The time of a late scratching, if applicable. */
  readonly lateScratchingTime?: Maybe<Scalars['TimeStamp']>;
  /** The finishing margin in lengths between this competitor and the winner. Winner will be set to 0 */
  readonly margin?: Maybe<Scalars['Float']>;
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /** The starting row for the competitor, used for Harness racing. */
  readonly row: Scalars['String'];
  /** The unique runner entity associated with this competitor. */
  readonly runner: Runner;
  /** @deprecated scratched is deprecated, use scratchingType instead */
  readonly scratched: Scalars['Boolean'];
  /** The scratching status of the competitor (e.g., STARTER, SCRATCHED, LATESCRATCHING). */
  readonly scratchingType: ScratchingType;
  /** The sex of the competitor (e.g., Colt, Filly, Gelding). */
  readonly sex: CompetitorSex;
  /** A description of the colors and patterns of the jockey's silks. */
  readonly silksColour: Scalars['String'];
  /** The runner number assigned to the competitor. */
  readonly tabNo: Scalars['Int'];
  /** The name of the competitor's trainer. */
  readonly trainer: Scalars['String'];
  /** The unique internal identifier for the trainer. */
  readonly trainerID: Scalars['ID'];
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
  readonly weightAllocated: Scalars['Float'];
  readonly weightTotal: Scalars['Float'];
};

export type DateRange = {
  readonly from: Scalars['Time'];
  readonly to: Scalars['Time'];
};

export type DecimalRange = {
  readonly __typename?: 'DecimalRange';
  readonly end?: Maybe<Scalars['Float']>;
  readonly start?: Maybe<Scalars['Float']>;
};

export type DecimalRangedPlacingStats = {
  readonly __typename?: 'DecimalRangedPlacingStats';
  readonly placingStats?: Maybe<PlacingStats>;
  readonly range?: Maybe<DecimalRange>;
};

export type DeductionRule4 = {
  readonly __typename?: 'DeductionRule4';
  readonly ActiveRunners: ReadonlyArray<ActiveRunnerRule4>;
  readonly FromTime: Scalars['TimeStamp'];
  readonly ScratchedRunners: ReadonlyArray<ScratchedRunnerRule4>;
  readonly ToTime: Scalars['TimeStamp'];
  readonly TotalDeduction: Scalars['Float'];
};

export type DeductionSet = {
  readonly __typename?: 'DeductionSet';
  readonly deductions: ReadonlyArray<Deductions>;
  /** Unavailable in subscription. */
  readonly emergencyCompetitor: Competitor;
  readonly emergencyTabNo: Scalars['Int'];
  readonly raceID: Scalars['ID'];
  /** Unavailable in subscription. */
  readonly scratchedCompetitor: Competitor;
  /** Deprecated. */
  readonly scratchedMedianPrice: Scalars['Float'];
  readonly scratchedTabNo: Scalars['Int'];
  readonly scratchedTime: Scalars['TimeStamp'];
  readonly source: Scalars['String'];
  readonly status: DeductionStatus;
};

export enum DeductionStatus {
  Final = 'FINAL',
  Interim = 'INTERIM',
  Unknown = 'UNKNOWN'
}

export enum DeductionType {
  Place = 'PLACE',
  Win = 'WIN'
}

export type Deductions = {
  readonly __typename?: 'Deductions';
  readonly deduction: Scalars['Float'];
  readonly scratchedMedianPrice: Scalars['Float'];
  readonly type: DeductionType;
};

export type Derivative = {
  readonly __typename?: 'Derivative';
  readonly marketId: Scalars['String'];
  readonly marketType: Scalars['String'];
  readonly raceId: Scalars['ID'];
  readonly races: ReadonlyArray<DerivativeRace>;
  readonly selectedMarkets: ReadonlyArray<DerivativeSelectedMarket>;
  readonly source: Scalars['String'];
  readonly status: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updateType: Scalars['String'];
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

export type DerivativeRace = {
  readonly __typename?: 'DerivativeRace';
  readonly number: Scalars['Int'];
  readonly results: ReadonlyArray<DerivativeResult>;
  readonly rule4Deductions: ReadonlyArray<Maybe<DeductionRule4>>;
  readonly runners: ReadonlyArray<DerivativeRunner>;
};

export type DerivativeResult = {
  readonly __typename?: 'DerivativeResult';
  readonly code: Scalars['String'];
  readonly deadHeatReduction: Scalars['Float'];
  readonly number: Scalars['Int'];
};

export type DerivativeRunner = {
  readonly __typename?: 'DerivativeRunner';
  /** A user-friendly string representation of the price at 2 decimal places. */
  readonly displayPrice: Scalars['String'];
  /** A textual representation of the derivative market outcome corresponding to number. */
  readonly name: Scalars['String'];
  /** A unique identifier representing a runner or outcome within the market. */
  readonly number: Scalars['Int'];
  /** The raw decimal value of the odds. */
  readonly price: Scalars['Float'];
  /** A list of all runner numbers associated with this market outcome. */
  readonly selectionRunners?: Maybe<ReadonlyArray<Scalars['Int']>>;
  /** The owning source of the market. */
  readonly source: Scalars['String'];
  /** The ScratchingType of this selection when it is associated with an individual runner. */
  readonly status: Scalars['String'];
};

export type DerivativeSelectedMarket = {
  readonly __typename?: 'DerivativeSelectedMarket';
  readonly meetingID: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
};

export type Detail = {
  readonly __typename?: 'Detail';
  readonly byClass?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byCondition?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byDistance?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byDistanceAndCondition?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byJockey?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byJumps?: Maybe<PlacingStats>;
  readonly byRaceCondition?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly bySurface?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byTrack?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byTrackAndDistance?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byTrails?: Maybe<PlacingStats>;
  readonly byTrainer?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byTrainerAndJockey?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly byWeight?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly misc?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
};

export type EventMarketEdge = {
  readonly __typename?: 'EventMarketEdge';
  readonly cursor: Scalars['ID'];
  readonly node?: Maybe<SportMarket>;
};

export type EventMarketsConnection = {
  readonly __typename?: 'EventMarketsConnection';
  readonly edges?: Maybe<ReadonlyArray<EventMarketEdge>>;
  readonly markets?: Maybe<ReadonlyArray<SportMarket>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly totalCount: Scalars['Int'];
};

/** Represents an exotic bet, which involves multiple outcomes either within a single race (e.g., Trifecta) or across multiple races (e.g., Quadrella). This type provides all the details needed to display, price, and place the bet. */
export type Exotic = {
  readonly __typename?: 'Exotic';
  /** A list of the declared dividends for winning combinations. */
  readonly dividends: ReadonlyArray<ExoticDividend>;
  /** A list of the individual races (legs) that make up this exotic bet. */
  readonly exoticRaces: ReadonlyArray<ExoticRace>;
  /** The unique internal identifier for this specific exotic bet. */
  readonly id: Scalars['String'];
  /** A boolean flag that is `true` if this exotic bet spans across multiple, separate meetings, making it a special event. */
  readonly isCrossMeeting: Scalars['Boolean'];
  /** The total size of the betting pool for this exotic. */
  readonly poolSize: Scalars['Int'];
  /** @deprecated races are being deprecated, use exoticRaces instead */
  readonly races: ReadonlyArray<Race>;
  /** The final results of the exotic bet, including winning combinations and payouts. */
  readonly results: ReadonlyArray<ExoticResult>;
  /** The data provider (e.g., a specific tote) offering this exotic bet. */
  readonly source: Scalars['String'];
  /** The identifier for this exotic bet from the specified data source. */
  readonly sourceId: Scalars['String'];
  /** The specific name of the exotic bet. if applicable. */
  readonly specialName: Scalars['String'];
  /** A list of associated tote products for this exotic bet, containing details on pool variations, bet styles, and stake limits. */
  readonly toteProducts: ReadonlyArray<ToteProduct>;
  /** The generic type of exotic bet (e.g., PICK4, TRIFECTA). This defines the general bet selection and placement behavior. */
  readonly type: BetType;
};

/** Maps a competitor's runner number to the unique selection ID required by the betting system to place exotic bets. */
export type ExoticCompetitor = {
  readonly __typename?: 'ExoticCompetitor';
  /** The competitor's official runner number for the race. */
  readonly runnerNumber: Scalars['Int'];
  /** The unique identifier for this competitor within the betting system, used when constructing bets. */
  readonly selectionId: Scalars['String'];
};

/** Represents a single dividend payout for a specific winning combination in an exotic bet. There can be multiple dividends if there are dead heats. */
export type ExoticDividend = {
  readonly __typename?: 'ExoticDividend';
  /** An array of runner numbers representing the winning combination. */
  readonly combination: ReadonlyArray<Scalars['Int']>;
  /** The price or dividend paid for this specific winning combination. */
  readonly price?: Maybe<Scalars['Float']>;
};

/** Represents a single race (or leg) within a multi-leg exotic bet. */
export type ExoticRace = {
  readonly __typename?: 'ExoticRace';
  /** A list of the competitors participating in this leg of the exotic, with their betting selection IDs. */
  readonly competitors: ReadonlyArray<ExoticCompetitor>;
  /** The unique identifier of the meeting this race belongs to. */
  readonly meetingId: Scalars['ID'];
  /** The full race object for this leg of the exotic, allowing access to all race details. */
  readonly race?: Maybe<Race>;
  /** The number of the race within its meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The selection ID for the 'unnamed favourite' option in this leg of the exotic bet. This allows a bet to be placed on whichever competitor becomes the official favourite at the start of the race, without selecting a specific runner in advance. This feature is typically supported for specific tote pools, often in UK racing. */
  readonly unnamedFavouriteSelectionId: Scalars['String'];
};

/** Describes the final result of an exotic bet, including the winning numbers and the dividend paid. */
export type ExoticResult = {
  readonly __typename?: 'ExoticResult';
  /** The final payout amount for a winning ticket. */
  readonly dividend: Scalars['Float'];
  /** A string representing the winning combination of runner numbers (e.g., '1,5,10'). */
  readonly dividendNumbers: Scalars['String'];
  /** The total size of the prize pool for this result. */
  readonly poolSize: Scalars['Float'];
};

/** Contains a real-time update payload for an exotic bet. */
export type ExoticUpdate = {
  readonly __typename?: 'ExoticUpdate';
  /** The updated list of dividends. */
  readonly dividends: ReadonlyArray<ExoticDividend>;
  /** Indicates if the exotic bet spans multiple meetings. */
  readonly isCrossMeeting: Scalars['Boolean'];
  /** The updated total size of the betting pool. */
  readonly poolSize: Scalars['Int'];
  /** A list of the races (legs) involved in this exotic bet with updated information. */
  readonly races: ReadonlyArray<ExoticRace>;
  /** The updated results for the exotic bet. */
  readonly results: ReadonlyArray<ExoticResult>;
  /** The data provider for this exotic bet. */
  readonly source: Scalars['String'];
  /** The specific name of the exotic bet, if applicable. */
  readonly specialName: Scalars['String'];
  /** The type of exotic bet being updated. */
  readonly type: BetType;
};

export type Filter = {
  readonly key: FilterKey;
  readonly value: Scalars['String'];
};

export enum FilterKey {
  Country = 'Country',
  MeetingType = 'MeetingType'
}

export type FormPlaceGetter = {
  readonly __typename?: 'FormPlaceGetter';
  readonly barrier: Scalars['Int'];
  readonly failedToFinishReason: Scalars['String'];
  readonly finishingPosition: Scalars['Int'];
  readonly jockeyGlobalId: Scalars['ID'];
  readonly jockeyName: Scalars['String'];
  readonly margin: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly runnerGlobalId: Scalars['ID'];
  readonly startingPrice: Scalars['Float'];
  readonly tabNumber: Scalars['Int'];
  readonly trainerGlobalId: Scalars['ID'];
  readonly trainerName: Scalars['String'];
  readonly weight: Scalars['Float'];
};

export type Fraction = {
  readonly __typename?: 'Fraction';
  readonly fractionNumber: Scalars['String'];
  readonly fractionPrint: Scalars['String'];
  readonly time: Scalars['Int'];
};

export type Futures = {
  readonly __typename?: 'Futures';
  readonly event: ReadonlyArray<FuturesEvent>;
  readonly serverTimestamp: Scalars['Int'];
};

export type FuturesEvent = {
  readonly __typename?: 'FuturesEvent';
  readonly acceptanceRaceNumber?: Maybe<Scalars['Int']>;
  readonly class: Scalars['String'];
  readonly country: Scalars['String'];
  readonly date: Scalars['Time'];
  readonly distance: Scalars['String'];
  readonly entryCondition: Scalars['String'];
  readonly externalIDs?: Maybe<ReadonlyArray<Maybe<SourceId>>>;
  readonly id: Scalars['Int'];
  readonly markets?: Maybe<ReadonlyArray<FuturesMarket>>;
  readonly meetingId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly prizeMoney: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly sportCategoryDescription: Scalars['String'];
  readonly sportCategoryId: Scalars['Int'];
  readonly sportTypeId: Scalars['Int'];
  readonly stage: Scalars['String'];
  readonly state: Scalars['String'];
  readonly status?: Maybe<FuturesEventStatus>;
  readonly urls?: Maybe<ReadonlyArray<FuturesUrl>>;
  readonly venue: Scalars['String'];
};


export type FuturesEventExternalIDsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};

export enum FuturesEventStatus {
  Open = 'Open',
  Resulted = 'Resulted',
  Suspended = 'Suspended'
}

export type FuturesForm = {
  readonly __typename?: 'FuturesForm';
  readonly SP: Scalars['Float'];
  readonly barrier: Scalars['Int'];
  readonly class: Scalars['String'];
  readonly date: Scalars['Time'];
  readonly distance: Scalars['Int'];
  readonly elapsedTime: Scalars['String'];
  readonly jockey: Scalars['String'];
  readonly margin: Scalars['Float'];
  readonly placing: Scalars['String'];
  readonly raceNo: Scalars['Int'];
  readonly startCount: Scalars['Int'];
  readonly starters: Scalars['Int'];
  readonly state: Scalars['String'];
  readonly stewardsComment: Scalars['String'];
  readonly trackCondition: Scalars['String'];
  readonly trackRating: Scalars['Int'];
  readonly trainer: Scalars['String'];
  readonly venue: Scalars['String'];
  readonly weight: Scalars['Float'];
};

export type FuturesMarket = {
  readonly __typename?: 'FuturesMarket';
  readonly selections?: Maybe<ReadonlyArray<FuturesSelection>>;
  readonly type: Scalars['String'];
};

export type FuturesNextRace = {
  readonly __typename?: 'FuturesNextRace';
  readonly details: Scalars['String'];
  readonly meetingId?: Maybe<Scalars['ID']>;
  readonly raceNumber?: Maybe<Scalars['Int']>;
};

export type FuturesPrice = {
  readonly __typename?: 'FuturesPrice';
  readonly price: Scalars['Float'];
  readonly source: Scalars['String'];
  readonly updated: Scalars['Time'];
};

export type FuturesSelection = {
  readonly __typename?: 'FuturesSelection';
  readonly aapID: Scalars['Int'];
  readonly acceptanceRunnerNumber?: Maybe<Scalars['Int']>;
  readonly form?: Maybe<ReadonlyArray<FuturesForm>>;
  readonly generatedPrice: ReadonlyArray<Price>;
  readonly marketSelectionId: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly nextRace?: Maybe<FuturesNextRace>;
  readonly placing?: Maybe<Scalars['Int']>;
  readonly prices?: Maybe<ReadonlyArray<FuturesPrice>>;
  readonly removedReason?: Maybe<FuturesSelectionReason>;
  readonly removedTime?: Maybe<Scalars['Time']>;
  readonly runnerNumber: Scalars['Int'];
  readonly silk?: Maybe<FuturesSilks>;
  readonly stats?: Maybe<FuturesStats>;
  readonly status: FuturesSelectionStatus;
  readonly trainer: Scalars['String'];
};

export enum FuturesSelectionReason {
  Injury = 'Injury',
  Na = 'NA',
  NotNominated = 'NotNominated'
}

export enum FuturesSelectionStatus {
  Active = 'Active',
  Injury = 'Injury',
  Loss = 'Loss',
  NotNominated = 'NotNominated',
  Place = 'Place',
  Suspended = 'Suspended',
  Void = 'Void',
  Win = 'Win'
}

export type FuturesSilks = {
  readonly __typename?: 'FuturesSilks';
  readonly colours: Scalars['String'];
  readonly image: Scalars['String'];
};

export type FuturesStats = {
  readonly __typename?: 'FuturesStats';
  readonly last6: Scalars['String'];
  readonly last10: Scalars['String'];
};

export type FuturesUrl = {
  readonly __typename?: 'FuturesUrl';
  readonly URL: Scalars['String'];
  readonly source: Scalars['String'];
};

/** Represents a major future racing event (e.g., a championship race) for which betting is open in advance. */
export type FuturesV2Event = {
  readonly __typename?: 'FuturesV2Event';
  /** The class or grade of the event (e.g., 'Group 1'). */
  readonly class: Scalars['String'];
  /** The country where the event will be held. */
  readonly country: Scalars['String'];
  /** The timestamp when the futures event was created. */
  readonly created: Scalars['TimeStamp'];
  /** The distance of the race. */
  readonly distance: Scalars['Int'];
  readonly entryCondition: Scalars['String'];
  readonly gbsId?: Maybe<Scalars['String']>;
  readonly gbsRaceNumber?: Maybe<Scalars['Int']>;
  /** The unique internal identifier for the futures event. */
  readonly id: Scalars['ID'];
  /** The official name of the event (e.g., 'The Everest'). */
  readonly name: Scalars['String'];
  /** The total prize money for the event. */
  readonly prize: Scalars['Int'];
  /** A list of the runners currently in the market for this event. */
  readonly runners: ReadonlyArray<FuturesV2Runner>;
  /** The current stage of the event (e.g., NOMINATIONS, FINAL_FIELD). */
  readonly stage: FuturesV2EventStage;
  /** The scheduled date and time of the event. */
  readonly startTime: Scalars['TimeStamp'];
  /** The state or region where the event will be held. */
  readonly state: Scalars['String'];
  /** The current status of the event market (e.g., OPEN, SUSPENDED, RESULTED). */
  readonly status: FuturesV2EventStatus;
  /** The type of racing (e.g., THOROUGHBRED). */
  readonly type: MeetingType;
  /** The timestamp of the last update to the event's information. */
  readonly updated: Scalars['TimeStamp'];
  /** The name of the venue or track hosting the event. */
  readonly venue: Scalars['String'];
};

export enum FuturesV2EventStage {
  FinalField = 'FINAL_FIELD',
  Nominations = 'NOMINATIONS',
  PreNominations = 'PRE_NOMINATIONS'
}

export enum FuturesV2EventStatus {
  Open = 'OPEN',
  Resulted = 'RESULTED',
  Suspended = 'SUSPENDED'
}

export type FuturesV2EventUpdate = {
  readonly __typename?: 'FuturesV2EventUpdate';
  readonly class?: Maybe<Scalars['String']>;
  readonly distance?: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly prize?: Maybe<Scalars['Int']>;
  readonly runners: ReadonlyArray<FuturesV2RunnerUpdate>;
  readonly stage?: Maybe<FuturesV2EventStage>;
  readonly status?: Maybe<FuturesV2EventStatus>;
  readonly updated: Scalars['TimeStamp'];
};

/** Represents a single competitor (runner) within a futures event market. */
export type FuturesV2Runner = {
  readonly __typename?: 'FuturesV2Runner';
  /** The timestamp when this runner was added to the futures event. */
  readonly created: Scalars['TimeStamp'];
  /** A history of the runner's previous race performances. */
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  /** The unique internal identifier for the runner. */
  readonly id: Scalars['ID'];
  /** The name of the runner. */
  readonly name: Scalars['String'];
  /** A description of the owner's racing silks (colors and patterns). */
  readonly silks: Scalars['String'];
  /** Statistics for the runner. */
  readonly stats: Statistics;
  /** The current status of the runner in the market (e.g., ACTIVE, SUSPENDED). */
  readonly status: FuturesV2RunnerStatus;
  /** The runner number assigned to the competitor in the futures market. */
  readonly tabNo: Scalars['Int'];
  /** The timestamp of the last update to this runner's information. */
  readonly updated: Scalars['TimeStamp'];
};

export enum FuturesV2RunnerStatus {
  Active = 'ACTIVE',
  Loss = 'LOSS',
  Place = 'PLACE',
  Suspended = 'SUSPENDED',
  Void = 'VOID',
  Win = 'WIN'
}

export type FuturesV2RunnerUpdate = {
  readonly __typename?: 'FuturesV2RunnerUpdate';
  readonly eventId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly silks?: Maybe<Scalars['String']>;
  readonly status?: Maybe<FuturesV2RunnerStatus>;
  readonly updated: Scalars['TimeStamp'];
};

export enum GateRangeType {
  GateRangeTypeInner = 'GATE_RANGE_TYPE_INNER',
  GateRangeTypeMiddle = 'GATE_RANGE_TYPE_MIDDLE',
  GateRangeTypeOuter = 'GATE_RANGE_TYPE_OUTER',
  GateRangeTypeUnknown = 'GATE_RANGE_TYPE_UNKNOWN'
}

export enum HarnessStartType {
  Mobile = 'Mobile',
  Standing = 'Standing'
}

export type InRun = {
  readonly __typename?: 'InRun';
  readonly distance: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly source: Scalars['String'];
};

export type Int32Range = {
  readonly __typename?: 'Int32Range';
  readonly end?: Maybe<Scalars['Int']>;
  readonly start?: Maybe<Scalars['Int']>;
};

export type Int32RangedPlacingStats = {
  readonly __typename?: 'Int32RangedPlacingStats';
  readonly placingStats?: Maybe<PlacingStats>;
  readonly range?: Maybe<Int32Range>;
};

export type JockeyIdentifier = {
  readonly __typename?: 'JockeyIdentifier';
  readonly globalId: Scalars['ID'];
  readonly meetingType: Scalars['String'];
  readonly name: Scalars['String'];
};

export type JockeyResult = {
  readonly __typename?: 'JockeyResult';
  readonly jockeyIdentifier: JockeyIdentifier;
  readonly sourceJockeys: ReadonlyArray<Maybe<JockeyIdentifier>>;
  readonly targetJockey: JockeyIdentifier;
};

export type KeyedPlacingStats = {
  readonly __typename?: 'KeyedPlacingStats';
  readonly averagePrice: Scalars['Float'];
  readonly averagePrizeMoneyWon: Scalars['Float'];
  readonly averageTimeSeconds: Scalars['Float'];
  readonly bestMileRateSeconds: Scalars['Float'];
  readonly bestTimeSeconds: Scalars['Float'];
  readonly biggestPrizeMoneyWon: Scalars['Float'];
  readonly firsts: Scalars['Int'];
  readonly key: Scalars['String'];
  readonly lastTimeSeconds: Scalars['Float'];
  readonly numberOfRuns: Scalars['Int'];
  readonly placePercentage: Scalars['Int'];
  readonly rating: Scalars['Float'];
  /** @deprecated No longer supported */
  readonly returnOnInvestment?: Maybe<ReturnOnInvestment>;
  readonly roundedAveragePrice: Scalars['Float'];
  readonly roundedAveragePrizeMoneyWon: Scalars['Float'];
  readonly seconds: Scalars['Int'];
  readonly thirds: Scalars['Int'];
  readonly top2Percentage: Scalars['Int'];
  readonly top3Percentage: Scalars['Int'];
  readonly top4Percentage: Scalars['Int'];
  readonly totalPrizeMoneyWon: Scalars['Float'];
  readonly winPercentage: Scalars['Int'];
};

export enum Language {
  English = 'ENGLISH',
  PortugueseBrazilian = 'PORTUGUESE_BRAZILIAN'
}

export type LiveForm = {
  readonly __typename?: 'LiveForm';
  /** average odds of winning competitors. */
  readonly averageOdds?: Maybe<LiveFormAverageOdds>;
  /** number of races won by the favourite. */
  readonly favouritePerformance?: Maybe<LiveFormFavouritePerformance>;
  /** % of winners that have come from the specified gates. Defaults to 1-3 if no gates specified. */
  readonly gatePerformance?: Maybe<LiveFormGatesPerformance>;
  /** % of winners that have come from the gates. */
  readonly gateRangePerformance?: Maybe<ReadonlyArray<LiveFormGateRangePerformanceNew>>;
  /** number of races won by the market movers. */
  readonly marketMovers?: Maybe<LiveFormMarketMovers>;
  /** % of driver that have the most wins. Only HARNESS. */
  readonly topDrivers?: Maybe<ReadonlyArray<LiveFormTopDriverNew>>;
  /** % of gates that have the most wins. Only THOROUGHBREDS and GREYHOUNDS. */
  readonly topGates?: Maybe<ReadonlyArray<LiveFormGatePerformanceNew>>;
  /** % of jockey that have the most wins. Only THOROUGHBREDS. */
  readonly topJockeys?: Maybe<ReadonlyArray<LiveFormTopJockeyNew>>;
  /** % of trainers that have the most wins. */
  readonly topTrainers?: Maybe<ReadonlyArray<LiveFormTopTrainerNew>>;
  /** % of winner that have come from settling track position */
  readonly trackBias?: Maybe<ReadonlyArray<LiveFormTrackBias>>;
};


export type LiveFormAverageOddsArgs = {
  source: Scalars['String'];
};


export type LiveFormFavouritePerformanceArgs = {
  source: Scalars['String'];
};


export type LiveFormGatePerformanceArgs = {
  gates?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};


export type LiveFormMarketMoversArgs = {
  source: Scalars['String'];
};

export type LiveFormAverageOdds = {
  readonly __typename?: 'LiveFormAverageOdds';
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** average odds of the resulted rides during this meeting. */
  readonly value: Scalars['Float'];
};

export type LiveFormFavouritePerformance = {
  readonly __typename?: 'LiveFormFavouritePerformance';
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won by the favorite during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the favorite during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormGatePerformance = {
  readonly __typename?: 'LiveFormGatePerformance';
  /** gate/barrier */
  readonly gate: Scalars['Int'];
  /** Is the gate considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate's remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormGatePerformanceNew = {
  readonly __typename?: 'LiveFormGatePerformanceNew';
  /** gate/barrier */
  readonly gate: Scalars['Int'];
  /** Is the gate considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate's remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormGatePerformanceNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormGateRangePerformance = {
  readonly __typename?: 'LiveFormGateRangePerformance';
  /** gate/barrier range as INNER, MIDDLE or OUTER */
  readonly gateRangeType: GateRangeType;
  /** Is the gate range considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate range’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
};

export type LiveFormGateRangePerformanceNew = {
  readonly __typename?: 'LiveFormGateRangePerformanceNew';
  /** gate/barrier range as INNER, MIDDLE or OUTER */
  readonly gateRangeType: GateRangeType;
  /** Is the gate range considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate range’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
};


export type LiveFormGateRangePerformanceNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormGatesPerformance = {
  readonly __typename?: 'LiveFormGatesPerformance';
  /** gate/barrier */
  readonly gates: ReadonlyArray<Scalars['Int']>;
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
};

export type LiveFormMarketMovers = {
  readonly __typename?: 'LiveFormMarketMovers';
  /** resulted rides for the meeting consisting of market movers. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won by the market movers during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the market movers during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopDriver = {
  readonly __typename?: 'LiveFormTopDriver';
  /** global driver ID. */
  readonly id: Scalars['ID'];
  /** Is the driver considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** driver's name. */
  readonly name: Scalars['String'];
  /** driver’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** driver’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won by the driver during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the driver during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopDriverNew = {
  readonly __typename?: 'LiveFormTopDriverNew';
  /** global driver ID. */
  readonly id: Scalars['ID'];
  /** Is the driver considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** driver's name. */
  readonly name: Scalars['String'];
  /** driver’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** driver’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won by the driver during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the driver during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormTopDriverNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormTopJockey = {
  readonly __typename?: 'LiveFormTopJockey';
  /** global jockey ID. */
  readonly id: Scalars['ID'];
  /** Is the jockey considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** jockey's name. */
  readonly name: Scalars['String'];
  /** jockey’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** jockey’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won by the jockey during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the jockey during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopJockeyNew = {
  readonly __typename?: 'LiveFormTopJockeyNew';
  /** global jockey ID. */
  readonly id: Scalars['ID'];
  /** Is the jockey considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** jockey's name. */
  readonly name: Scalars['String'];
  /** jockey’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** jockey’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won by the jockey during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the jockey during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormTopJockeyNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormTopTrainer = {
  readonly __typename?: 'LiveFormTopTrainer';
  /** global trainer ID. */
  readonly id: Scalars['ID'];
  /** Is the trainer considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** trainer's name. */
  readonly name: Scalars['String'];
  /** trainer’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** trainer’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won by the trainer during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the trainer during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopTrainerNew = {
  readonly __typename?: 'LiveFormTopTrainerNew';
  /** global trainer ID. */
  readonly id: Scalars['ID'];
  /** Is the trainer considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** trainer's name. */
  readonly name: Scalars['String'];
  /** trainer’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** trainer’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won by the trainer during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the trainer during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormTopTrainerNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormTrackBias = {
  readonly __typename?: 'LiveFormTrackBias';
  /** Is the pace considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** settlement pace on the track during this meeting */
  readonly paceCategory: PaceCategory;
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won from this pace during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this pace during this meeting. */
  readonly winCount: Scalars['Int'];
};

export type LiveFormUpcomingCompetitor = {
  readonly __typename?: 'LiveFormUpcomingCompetitor';
  readonly name: Scalars['String'];
  readonly tabNo: Scalars['Int'];
};

export type LiveFormUpcomingRace = {
  readonly __typename?: 'LiveFormUpcomingRace';
  readonly competitors?: Maybe<ReadonlyArray<LiveFormUpcomingCompetitor>>;
  readonly raceId: Scalars['ID'];
  readonly raceNo: Scalars['Int'];
};

export type LiveFormUpdated = {
  readonly __typename?: 'LiveFormUpdated';
  /** average odds of winning competitors. */
  readonly averageOdds?: Maybe<LiveFormAverageOdds>;
  /** number of races won by the favourite. */
  readonly favouritePerformance?: Maybe<LiveFormFavouritePerformance>;
  /** % of winners that have come from the gates. */
  readonly gateRangePerformance?: Maybe<ReadonlyArray<LiveFormGateRangePerformance>>;
  /** Meeting ID */
  readonly id: Scalars['ID'];
  /** number of races won by the market movers. */
  readonly marketMovers?: Maybe<LiveFormMarketMovers>;
  /** % of driver that have the most wins. Only HARNESS. */
  readonly topDrivers?: Maybe<ReadonlyArray<LiveFormTopDriver>>;
  /** % of gates that have the most wins. Only THOROUGHBREDS and GREYHOUNDS. */
  readonly topGates?: Maybe<ReadonlyArray<LiveFormGatePerformance>>;
  /** % of jockey that have the most wins. Only THOROUGHBREDS. */
  readonly topJockeys?: Maybe<ReadonlyArray<LiveFormTopJockey>>;
  /** % of trainers that have the most wins. */
  readonly topTrainers?: Maybe<ReadonlyArray<LiveFormTopTrainer>>;
  /** % of winner that have come from settling track position */
  readonly trackBias?: Maybe<ReadonlyArray<LiveFormTrackBias>>;
};

export type MarketSelectionEdge = {
  readonly __typename?: 'MarketSelectionEdge';
  readonly cursor: Scalars['ID'];
  readonly node?: Maybe<SportSelection>;
};

export type MarketSelectionsConnection = {
  readonly __typename?: 'MarketSelectionsConnection';
  readonly edges?: Maybe<ReadonlyArray<MarketSelectionEdge>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly selections?: Maybe<ReadonlyArray<SportSelection>>;
  readonly totalCount: Scalars['Int'];
};

/** Represents a single race meeting event, held at a specific track on a given date. */
export type Meeting = {
  readonly __typename?: 'Meeting';
  /** The advanced track condition, often provided before the official track rating. */
  readonly advancedGoing: Scalars['String'];
  /** The timestamp when the meeting was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The official date of the meeting in UTC. */
  readonly date: Scalars['TimeStamp'];
  /** A list of external identifiers for this meeting from various data sources. Can be filtered by source. */
  readonly externalIDs?: Maybe<ReadonlyArray<Maybe<SourceId>>>;
  /** The scheduled start time of the first race of the meeting. */
  readonly firstRaceTime: Scalars['TimeStamp'];
  /** Live form and stats as the meeting progresses. This data has permissions and may incur additional charges. Please speak to our representative if you are interested. */
  readonly form?: Maybe<LiveForm>;
  /** A flag indicating if there is vision (video) coverage available for the meeting. */
  readonly hasVision: Scalars['Boolean'];
  /** The unique internal identifier for the meeting. */
  readonly id: Scalars['ID'];
  /** Returns multi-leg exotic bet types for this meeting. Can be filtered by bet type and source. */
  readonly multiLegExotics: ReadonlyArray<Exotic>;
  /** A list of races for this meeting. Can be filtered by a specific race number. */
  readonly races: ReadonlyArray<Race>;
  /** The position of the rail on the track for this meeting. */
  readonly railPosition: Scalars['String'];
  /** To indicate if the meeting is covered by TAB. */
  readonly tabIndicator: Scalars['String'];
  /** The track where the meeting is being held. */
  readonly track: Track;
  /** The type of racing. */
  readonly type: MeetingType;
  /** The timestamp of the last update to the meeting's information. */
  readonly updated: Scalars['TimeStamp'];
};


/** Represents a single race meeting event, held at a specific track on a given date. */
export type MeetingExternalIDsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents a single race meeting event, held at a specific track on a given date. */
export type MeetingMultiLegExoticsArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  type?: InputMaybe<BetType>;
};


/** Represents a single race meeting event, held at a specific track on a given date. */
export type MeetingRacesArgs = {
  raceNumber?: InputMaybe<Scalars['Int']>;
};

export enum MeetingType {
  Greyhound = 'GREYHOUND',
  Harness = 'HARNESS',
  Thoroughbred = 'THOROUGHBRED'
}

/** Contains a payload of real-time updates for a specific meeting. */
export type MeetingUpdate = {
  readonly __typename?: 'MeetingUpdate';
  /** The timestamp when the meeting was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The official date and time of the meeting. */
  readonly date: Scalars['TimeStamp'];
  /** An updated list of external identifiers for this meeting from various data sources. */
  readonly externalIDs?: Maybe<ReadonlyArray<Maybe<SourceId>>>;
  /** The id identifier for the meeting. */
  readonly id: Scalars['ID'];
  /** To indicate if the meeting is covered by TAB. */
  readonly tabIndicator: Scalars['String'];
  /** A payload of updated information for the track where the meeting is held. */
  readonly track: TrackUpdate;
  /** The type of racing for the meeting (e.g., THOROUGHBRED, HARNESS, GREYHOUND). */
  readonly type: MeetingType;
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
};


/** Contains a payload of real-time updates for a specific meeting. */
export type MeetingUpdateExternalIDsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};

export enum PaceCategory {
  Backmarker = 'BACKMARKER',
  LeadOnPace = 'LEAD_ON_PACE',
  OffPaceMidfield = 'OFF_PACE_MIDFIELD',
  Unknown = 'UNKNOWN'
}

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly endCursor: Scalars['ID'];
  readonly hasNextPage: Scalars['Boolean'];
  readonly startCursor: Scalars['ID'];
};

export type Performance = {
  readonly __typename?: 'Performance';
  readonly a2eCareer: Scalars['Float'];
  readonly a2eLast100: Scalars['Float'];
  readonly classChange: Scalars['Float'];
  readonly conditionBenchMark: Scalars['Float'];
  readonly distanceBenchMark: Scalars['Float'];
  readonly last2YearsBenchMark: Scalars['Float'];
  readonly last200ConditionBenchMark: Scalars['Float'];
  readonly last200DistanceBenchMark: Scalars['Float'];
  readonly last200Last2YearsBenchMark: Scalars['Float'];
  readonly last200LastStartBenchMark: Scalars['Float'];
  readonly last200PrepStartBenchMark: Scalars['Float'];
  readonly last600ConditionBenchMark: Scalars['Float'];
  readonly last600DistanceBenchMark: Scalars['Float'];
  readonly last600Last2YearsBenchMark: Scalars['Float'];
  readonly last600LastStartBenchMark: Scalars['Float'];
  readonly last600PrepStartBenchMark: Scalars['Float'];
  readonly lastStartBenchMark: Scalars['Float'];
  readonly mapA2E: Scalars['Float'];
  readonly potCareer: Scalars['Float'];
  readonly potLast100: Scalars['Float'];
  readonly prepStartBenchMark: Scalars['Float'];
  readonly settle: Scalars['Int'];
  readonly speed: Scalars['Int'];
  readonly wsrCareer: Scalars['Float'];
  readonly wsrLast100: Scalars['Float'];
};

export type PerformanceRating = {
  readonly __typename?: 'PerformanceRating';
  readonly Name: Scalars['String'];
  readonly Source: Scalars['String'];
  readonly Value: Scalars['Float'];
};

export type Performances = {
  readonly __typename?: 'Performances';
  readonly jockey?: Maybe<Performance>;
  readonly runner?: Maybe<Performance>;
  readonly trainer?: Maybe<Performance>;
  readonly trainerJockey?: Maybe<Performance>;
};

export type PlacingStats = {
  readonly __typename?: 'PlacingStats';
  readonly averagePrice?: Maybe<Scalars['Float']>;
  readonly averagePrizeMoneyWon?: Maybe<Scalars['Float']>;
  readonly averageTimeSeconds?: Maybe<Scalars['Float']>;
  readonly bestMileRateSeconds: Scalars['Float'];
  readonly bestTimeSeconds: Scalars['Float'];
  readonly biggestPrizeMoneyWon?: Maybe<Scalars['Float']>;
  readonly firsts?: Maybe<Scalars['Int']>;
  readonly lastTimeSeconds: Scalars['Float'];
  readonly numberOfRuns?: Maybe<Scalars['Int']>;
  readonly placePercentage?: Maybe<Scalars['Int']>;
  readonly rating: Scalars['Float'];
  /** @deprecated No longer supported */
  readonly returnOnInvestment?: Maybe<ReturnOnInvestment>;
  readonly roundedAveragePrice?: Maybe<Scalars['Float']>;
  readonly roundedAveragePrizeMoneyWon?: Maybe<Scalars['Float']>;
  readonly seconds?: Maybe<Scalars['Int']>;
  readonly thirds?: Maybe<Scalars['Int']>;
  readonly top2Percentage: Scalars['Int'];
  readonly top3Percentage: Scalars['Int'];
  readonly top4Percentage: Scalars['Int'];
  readonly totalPrizeMoneyWon?: Maybe<Scalars['Float']>;
  readonly winPercentage?: Maybe<Scalars['Int']>;
};

export enum PlatformType {
  PlatformTypeFixed = 'PLATFORM_TYPE_FIXED',
  PlatformTypeTote = 'PLATFORM_TYPE_TOTE',
  PlatformTypeUnknown = 'PLATFORM_TYPE_UNKNOWN'
}

export type PointOfCall = {
  readonly __typename?: 'PointOfCall';
  readonly lengthsAhead: Scalars['Int'];
  readonly lengthsBehind: Scalars['Int'];
  readonly pointOfCallId: Scalars['String'];
  readonly pointOfCallPrint: Scalars['String'];
  readonly position: Scalars['Int'];
};

/** A real-time update payload for changes to a race's pre-jump status. */
export type PreJumpRaceStatusUpdate = {
  readonly __typename?: 'PreJumpRaceStatusUpdate';
  /** The id of the race being updated. */
  readonly id: Scalars['ID'];
  /** The id of the meeting this race belongs to. */
  readonly meetingId: Scalars['ID'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The pre-jump status. */
  readonly status: PreJumpStatus;
  /** The timestamp when this pre-jump status update occurred. */
  readonly updated: Scalars['TimeStamp'];
};

export enum PreJumpStatus {
  BehindTheGate = 'BEHIND_THE_GATE',
  Delay = 'DELAY',
  FirstHorseIn = 'FIRST_HORSE_IN',
  FiveHorseIn = 'FIVE_HORSE_IN',
  GoingBehind = 'GOING_BEHIND',
  GoingDown = 'GOING_DOWN',
  LastHorseIn = 'LAST_HORSE_IN',
  LateScratched = 'LATE_SCRATCHED',
  OneToGo = 'ONE_TO_GO',
  RaceJumped = 'RACE_JUMPED',
  SevenHorseIn = 'SEVEN_HORSE_IN',
  SixHorseIn = 'SIX_HORSE_IN',
  ThreeToGo = 'THREE_TO_GO',
  TwoToGo = 'TWO_TO_GO',
  Unauthorised = 'UNAUTHORISED',
  Unknown = 'UNKNOWN'
}

export type PredictedRating = {
  readonly __typename?: 'PredictedRating';
  readonly allPreviousRatings: Scalars['String'];
  readonly averageMargin: Scalars['Float'];
  readonly careerBestRating: Scalars['Float'];
  readonly lastStartRating: Scalars['Float'];
  readonly morningLine: Scalars['Float'];
  readonly predictedPrice: Scalars['Float'];
  readonly predictedPriceHundredThirty: Scalars['Float'];
  readonly predictedRating: Scalars['Float'];
  readonly raceAdjustedRating: Scalars['Float'];
  readonly raceExpectedSpeed: Scalars['Float'];
  readonly raceRating: Scalars['Float'];
  readonly raceRawRating: Scalars['Float'];
  readonly raceRawRatingAvg: Scalars['Float'];
  readonly raceStandardTime: Scalars['Float'];
  readonly raceTrackVariant: Scalars['Float'];
  readonly ratingHorseId: Scalars['Int'];
  readonly secondLastStartRating: Scalars['Float'];
  readonly standardDeviation: Scalars['Float'];
  readonly tabNo: Scalars['Int'];
  readonly thirdLastStartRating: Scalars['Float'];
};

export type PredictedRatingUpdate = {
  readonly __typename?: 'PredictedRatingUpdate';
  readonly allPreviousRatings: Scalars['String'];
  readonly averageMargin: Scalars['Float'];
  readonly careerBestRating: Scalars['Float'];
  readonly lastStartRating: Scalars['Float'];
  readonly morningLine: Scalars['Float'];
  readonly predictedPrice: Scalars['Float'];
  readonly predictedPriceHundredThirty: Scalars['Float'];
  readonly predictedRating: Scalars['Float'];
  readonly raceAdjustedRating: Scalars['Float'];
  readonly raceExpectedSpeed: Scalars['Float'];
  readonly raceID: Scalars['String'];
  readonly raceRating: Scalars['Float'];
  readonly raceRawRating: Scalars['Float'];
  readonly raceRawRatingAvg: Scalars['Float'];
  readonly raceStandardTime: Scalars['Float'];
  readonly raceTrackVariant: Scalars['Float'];
  readonly ratingHorseId: Scalars['Int'];
  readonly secondLastStartRating: Scalars['Float'];
  readonly standardDeviation: Scalars['Float'];
  readonly tabNo: Scalars['Int'];
  readonly thirdLastStartRating: Scalars['Float'];
};

/** Represents the odds for a single competitor in a specific market (e.g., the Win price for horse #5). */
export type Price = {
  readonly __typename?: 'Price';
  /** A user-friendly string representation of the price at 2 decimal places. */
  readonly displayPrice: Scalars['String'];
  /** The raw decimal value of the odds. */
  readonly price: Scalars['Float'];
  /** The data provider that is offering this price. */
  readonly source: Scalars['String'];
  /** The runner number of the competitor this price applies to. */
  readonly tabNo: Scalars['Int'];
  /** The type of market this price belongs to (e.g., WIN, PLACE_FIXED_ODDS). */
  readonly type: PriceType;
  /** The timestamp when this specific price was last updated. */
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

/** Represents a single price fluctuation for a competitor, capturing a snapshot of their odds at a specific time. */
export type PriceFluc = {
  readonly __typename?: 'PriceFluc';
  /** The new decimal odds for the competitor at the recorded time. */
  readonly price: Scalars['Float'];
  /** The runner number of the competitor whose price has fluctuated. */
  readonly tabNo: Scalars['Int'];
  /** The exact time at which the price fluctuation was recorded. */
  readonly time: Scalars['TimeStamp'];
};

/** Represents a set of prices for a specific market type (e.g., Win, Place) from a single data source for a given race. */
export type PriceSet = {
  readonly __typename?: 'PriceSet';
  /** The unique identifier for the meeting this price set belongs to. */
  readonly meetingID: Scalars['String'];
  /** The total amount of money in the betting pool for this market type, if applicable. */
  readonly poolSize: Scalars['Int'];
  /** A list of the individual prices for each competitor in this market. */
  readonly prices: ReadonlyArray<Price>;
  /** The unique identifier for the race this price set belongs to. */
  readonly raceId: Scalars['String'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The data provider for this set of prices (e.g., a specific tote or bookmaker). */
  readonly source: Scalars['String'];
  /** Indicates if the market is currently suspended. For generated prices, 'Suspend Pricing On Insufficient Weighting' needs to be enabled on your PM account. */
  readonly suspendedPrice: Scalars['Boolean'];
  /** The type of market this price set represents (e.g., WIN, PLACE_FIXED_ODDS). */
  readonly type: PriceType;
  /** The timestamp of the last update to this price set. */
  readonly updated: Scalars['TimeStamp'];
};

export enum PriceType {
  MorningLineWin = 'MORNING_LINE_WIN',
  Place = 'PLACE',
  Place_2 = 'PLACE_2',
  PlaceFixedOdds = 'PLACE_FIXED_ODDS',
  PlaceFixedOdds2 = 'PLACE_FIXED_ODDS2',
  Win = 'WIN',
  WinFixedOdds = 'WIN_FIXED_ODDS'
}

export type Prizes = {
  readonly __typename?: 'Prizes';
  readonly type: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type ProInsight = {
  readonly __typename?: 'ProInsight';
  /** Insight's grouping. */
  readonly category: Scalars['String'];
  /** Insight's comment. */
  readonly comment: Scalars['String'];
  /** Betmakers' priority of importance in the UI. */
  readonly displayOrder: Scalars['Int'];
  /** Insight's key. */
  readonly key: Scalars['String'];
  /** Insight's name. */
  readonly name: Scalars['String'];
  /** Insight's runner number. */
  readonly runnerNumber: Scalars['Int'];
  /** Insight's Sentiment. E.g.,: positive or negative. */
  readonly sentiment: Scalars['String'];
};

export type Query = {
  readonly __typename?: 'Query';
  /** Returns a single, specific futures event by its unique ID. */
  readonly futureEvent: FuturesV2Event;
  /** Returns future racing events. Use the optional `range` argument to get events scheduled between the 'from' and 'to' dates. If the range is omitted, all future events will be returned. */
  readonly futureEvents: ReadonlyArray<FuturesV2Event>;
  /** Returns futures markets for major upcoming events within a specified date range. Note: This is a legacy futures query; for new integrations, please use `futureEvents`. */
  readonly futures: Futures;
  /** Returns a single meeting and all its associated race data. You must provide either the unique internal `id` or an `externalID` (which combines a `source` and the `sourceId` from that provider). */
  readonly meeting?: Maybe<Meeting>;
  /** Returns a list of meetings. Use `date` for a single day's meetings (format: `YYYY-MM-DDT00:00:00Z` - Time always set to zero.), or `firstRaceFrom` and `to` for meetings where the first race is within that specific time range. The `to` date can be at most 5 days after the `from` date. */
  readonly meetingsDated: ReadonlyArray<Meeting>;
  /** Returns multi-race exotic bet types (e.g. Quaddies, Pick4, etc) for a given date or date range. Can be filtered by bet `type`, data `sources`, and optionally constrained to only those exotics that span multiple meetings. */
  readonly multiLegExoticsDated: ReadonlyArray<Exotic>;
  /** Returns a single race and all its details, including competitors. You must provide either the unique internal `id` or an `externalID` (which combines a `source` and the `sourceId` from that provider). */
  readonly race?: Maybe<Race>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly raceJockey?: Maybe<RaceJockey>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly raceRunner?: Maybe<RaceRunner>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly raceTrainer?: Maybe<RaceTrainer>;
  /** Returns a list of races. A `from` start time is mandatory. The results can be filtered to `include` or `exclude` specific criteria (like `MeetingType` or `Country`) and the total number of returned races can be capped using `limit`. Default `limit` is set to 10. */
  readonly races: ReadonlyArray<Race>;
  readonly resolveRacelabInsightsUpdated: RacelabInsightsUpdated;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly runner?: Maybe<Runner>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly searchRaceJockeys: ReadonlyArray<Maybe<JockeyResult>>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly searchRaceRunners: ReadonlyArray<Maybe<RunnerResult>>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly searchRaceTrainers: ReadonlyArray<Maybe<TrainerResult>>;
  /** Returns the list of data providers available based on your account's permissions. Optionally, filter for a single provider by passing its code. */
  readonly sources: ReadonlyArray<Source>;
  /** Returns sport categories, which group competitions. Can be filtered by `categoryIds`, `name`, or `sportTypeId`. */
  readonly sportCategories?: Maybe<ReadonlyArray<SportCategory>>;
  /** Returns sport competitions (leagues, tournaments). Can be filtered by `competitionId` or `name`. */
  readonly sportCompetitions?: Maybe<ReadonlyArray<SportCompetition>>;
  /** Returns a list of sporting events (matches, games) based on a wide range of filters like `eventId`, `name`, `startDate`, `endDate`, etc. Results are paginated. */
  readonly sportEvents: ReadonlyArray<SportEvent>;
  /** Returns the betting markets for a given sporting event. Requires an `eventId` and allows for filtering by `marketName`. Results are paginated. */
  readonly sportMarkets?: Maybe<ReadonlyArray<SportMarket>>;
  /** Returns the results for markets within a specific sporting event. Requires an `eventId` and can be filtered by specific `marketIds`. */
  readonly sportResults?: Maybe<ReadonlyArray<SportMarketResult>>;
  /** Returns a list of all available data providers for sports data. */
  readonly sportSources: ReadonlyArray<Maybe<SportSource>>;
  /** Returns a list of all available sport types */
  readonly sportTypes: ReadonlyArray<Maybe<SportType>>;
  /** Returns a single track by its unique `id`. */
  readonly track?: Maybe<Track>;
  /** Returns a complete list of all available racing tracks (venues) in the system. */
  readonly tracks?: Maybe<ReadonlyArray<Track>>;
  /** Returns the results and dividends for a single completed virtual race, identified by its `race_id`. */
  readonly virtualRaceResult: VirtualRaceResult;
  /** Returns available betting selections and odds for a virtual race. Requires the `race_id` and can be filtered by the desired `betTypes`. */
  readonly virtualRaceSelection: VirtualSelections;
  /** Returns details for virtual races from a specific `source`, optionally filtering by a list of `ids`. */
  readonly virtualRaces: ReadonlyArray<VirtualRace>;
};


export type QueryFutureEventArgs = {
  id: Scalars['ID'];
};


export type QueryFutureEventsArgs = {
  range?: InputMaybe<DateRange>;
};


export type QueryFuturesArgs = {
  endDate?: InputMaybe<Scalars['Time']>;
  serverTimestamp?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Time']>;
};


export type QueryMeetingArgs = {
  externalID?: InputMaybe<InputSourceId>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMeetingsDatedArgs = {
  date?: InputMaybe<Scalars['Time']>;
  firstRaceFrom?: InputMaybe<Scalars['Time']>;
  to?: InputMaybe<Scalars['Time']>;
};


export type QueryMultiLegExoticsDatedArgs = {
  date?: InputMaybe<Scalars['Time']>;
  firstRaceFrom?: InputMaybe<Scalars['Time']>;
  onlyIncludeCrossMeetings?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  to?: InputMaybe<Scalars['Time']>;
  type?: InputMaybe<BetType>;
};


export type QueryRaceArgs = {
  externalID?: InputMaybe<InputSourceRaceId>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRaceJockeyArgs = {
  formHistoryLimit?: InputMaybe<Scalars['Int']>;
  formHistoryStart?: InputMaybe<Scalars['Int']>;
  globalId?: InputMaybe<Scalars['ID']>;
};


export type QueryRaceRunnerArgs = {
  formHistoryLimit?: InputMaybe<Scalars['Int']>;
  formHistoryStart?: InputMaybe<Scalars['Int']>;
  globalId?: InputMaybe<Scalars['ID']>;
};


export type QueryRaceTrainerArgs = {
  formHistoryLimit?: InputMaybe<Scalars['Int']>;
  formHistoryStart?: InputMaybe<Scalars['Int']>;
  globalId?: InputMaybe<Scalars['ID']>;
};


export type QueryRacesArgs = {
  exclude?: InputMaybe<ReadonlyArray<InputMaybe<Filter>>>;
  from: Scalars['Time'];
  include?: InputMaybe<ReadonlyArray<InputMaybe<Filter>>>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Time']>;
};


export type QueryRunnerArgs = {
  id: Scalars['ID'];
};


export type QuerySearchRaceJockeysArgs = {
  jockeyName?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  pageLimit?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchRaceRunnersArgs = {
  countryOfBirth?: InputMaybe<Scalars['String']>;
  damName?: InputMaybe<Scalars['String']>;
  maxDob?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  minDob?: InputMaybe<Scalars['String']>;
  pageLimit?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
  runnerName?: InputMaybe<Scalars['String']>;
  sireName?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRaceTrainersArgs = {
  meetingType?: InputMaybe<Scalars['String']>;
  pageLimit?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
  trainerName?: InputMaybe<Scalars['String']>;
};


export type QuerySourcesArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QuerySportCategoriesArgs = {
  categoryIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  sportTypeId?: InputMaybe<Scalars['Int']>;
};


export type QuerySportCompetitionsArgs = {
  competitionId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QuerySportEventsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Time']>;
  eventId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  round?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Time']>;
};


export type QuerySportMarketsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['ID']>;
  marketName?: InputMaybe<Scalars['String']>;
};


export type QuerySportResultsArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
  marketIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


export type QueryTrackArgs = {
  id: Scalars['ID'];
};


export type QueryVirtualRaceResultArgs = {
  race_id: Scalars['String'];
};


export type QueryVirtualRaceSelectionArgs = {
  betTypes?: InputMaybe<ReadonlyArray<VirtualBetType>>;
  race_id: Scalars['String'];
};


export type QueryVirtualRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
};

export type QuickInsight = {
  readonly __typename?: 'QuickInsight';
  /** Insight's key. */
  readonly key: Scalars['String'];
  /** Insight's name. */
  readonly name: Scalars['String'];
  /** Insight's percentage. */
  readonly percentage: Scalars['Int'];
  /** Insight's runner number. */
  readonly runnerNumber: Scalars['Int'];
  /** Insight's value. */
  readonly value: Scalars['Float'];
};

export type RacelabInsights = {
  readonly __typename?: 'RACELABInsights';
  readonly pro?: Maybe<ReadonlyArray<ProInsight>>;
  readonly quick?: Maybe<ReadonlyArray<QuickInsight>>;
};

export type RacelabInsightsUpdated = {
  readonly __typename?: 'RACELABInsightsUpdated';
  /** Pro insights. */
  readonly pro?: Maybe<ReadonlyArray<ProInsight>>;
  /** Quick insights. */
  readonly quick?: Maybe<ReadonlyArray<QuickInsight>>;
  /** Race ID */
  readonly raceId: Scalars['ID'];
};

/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type Race = {
  readonly __typename?: 'Race';
  /** BetFair market information for the race. If `priceType` is not specified, it returns the win market. Requires Betfair price permission. */
  readonly betFairMarkets?: Maybe<BetFairMarket>;
  /** The class or grade of the race (e.g., Group 1, Maiden). */
  readonly class: Scalars['String'];
  /** @deprecated comment is deprecated, use `comments(source)` instead */
  readonly comment: Scalars['String'];
  /** Analyst comments and tips for the race, filterable by language and source. Permissions required for additional languages. */
  readonly comments: ReadonlyArray<SourceComment>;
  /** A list of competitors in the race. Can be filtered by a specific runner number. */
  readonly competitors: ReadonlyArray<Competitor>;
  /** URL for the course map image. This data may require special permissions and incur additional charges. Please contact us for more information. */
  readonly courseMapURL: Scalars['String'];
  /** The timestamp when the race was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** Deduction information for the race, typically for regulated markets like Victorian Thoroughbreds. Can be filtered by `source` and option to include emergencies. */
  readonly deductionSet: ReadonlyArray<DeductionSet>;
  /** The distance of the race. */
  readonly distance: Scalars['Int'];
  /** The official time duration of the race from start to finish. */
  readonly duration: Scalars['String'];
  /** The number of places paid for each-way bets. */
  readonly eachWayPlaces: Scalars['Int'];
  /** The reduction factor applied to each-way bets. */
  readonly eachWayReduction: Scalars['Int'];
  /** Exotic betting products available for this race, such as Trifecta or Quinella. Can be filtered by bet type and source. */
  readonly exotics: ReadonlyArray<Exotic>;
  /** The race's identifier from a specific external data source. */
  readonly externalId: Scalars['String'];
  /** Indicates if fixed odds betting is available for this race. */
  readonly fixedAvailable: Scalars['Boolean'];
  /** The gait of the race, primarily for Harness racing (e.g., Pace, Trot). */
  readonly gait: Scalars['String'];
  /** A list of generated derivative markets for the race, filterable by source. */
  readonly generatedDerivatives: ReadonlyArray<Derivative>;
  /** Indicates if the race is a handicap race. */
  readonly handicap: Scalars['Boolean'];
  /** The start type for Harness races (e.g., Standing, Mobile). */
  readonly harnessStartType?: Maybe<HarnessStartType>;
  /** Indicates if speedmaps are available for this race. */
  readonly hasSpeedmaps: Scalars['Boolean'];
  /** The unique internal identifier for the race. */
  readonly id: Scalars['ID'];
  /** The official jump time of the race in UTC. */
  readonly jumpTime?: Maybe<Scalars['TimeStamp']>;
  /** The meeting this race belongs to. */
  readonly meeting: Meeting;
  /** The official name of the race. */
  readonly name: Scalars['String'];
  /** The race number within the meeting. */
  readonly number: Scalars['Int'];
  /** The number of paid places for the race. */
  readonly numberOfPlaces: Scalars['Int'];
  /** Historical pool data, implemented only on Tote Win/Place markets. Price source permission is required. */
  readonly poolHistory: ReadonlyArray<PriceSet>;
  /** Information about tote pools for the race, filterable by source. */
  readonly pools?: Maybe<ReadonlyArray<RacePool>>;
  /** The status of the race just before the jump (e.g., GOING_BEHIND, LAST_HORSE_IN). */
  readonly preJumpStatus: PreJumpStatus;
  /** A list of price sets (e.g., Win, Place) for the race, filterable by source. */
  readonly priceSets: ReadonlyArray<PriceSet>;
  /** The total prize money for the race. */
  readonly prizeMoney: Scalars['Int'];
  /** A breakdown of the prize money distribution for each finishing position. */
  readonly prizes: ReadonlyArray<Prizes>;
  /** Details on the restrictions for competitors in the race (e.g., age, sex). */
  readonly restrictions: Restrictions;
  /** The official results for the race. Can be filtered by source and can optionally include interim results. */
  readonly results: ReadonlyArray<ResultSet>;
  /** Rule 4 deduction information, typically for UK races. Can be filtered by source and deduction type. */
  readonly rule4: ReadonlyArray<Rule4>;
  /** Sectional times for the race. */
  readonly sectionals: ReadonlyArray<RaceSectional>;
  /** The types of selections available for the race. */
  readonly selections: ReadonlyArray<RaceSelectionType>;
  /** The Sky Racing channel number broadcasting the race. Permission required. */
  readonly skyChannel: Scalars['Int'];
  /** Speedmap data for the race, filterable by source. */
  readonly speedMaps: ReadonlyArray<RaceSpeedMap>;
  /** Only for Same Race Multi clients. Lists the prices for the market, including win and top 2/3/4 prices for a given market and customer. */
  readonly srmListPrices: ReadonlyArray<SrmListPrice>;
  /**
   * Only for Same Race Multi clients. Calculates the price for a set of SRM selections.
   * - `maxPrice` defaults to 10001 if not provided. The calculated price will be capped at this value.
   * - `legs`: Each selection must include all relevant positions (e.g., for 'Top 3', pass `positions: [1, 2, 3]`).
   * - `margin` should be a value over 100.
   */
  readonly srmPriceSelections: SrmSelectionPrice;
  /** The scheduled start time of the race. */
  readonly startTime: Scalars['TimeStamp'];
  /** The number of official starters in the race. */
  readonly starters: Scalars['Int'];
  /** The current status of the race (e.g., OPEN, FINAL, ABANDONED). */
  readonly status: RaceStatus;
  /** The type of surface the race is run on (e.g., Turf, Synthetic). */
  readonly surfaceType: Scalars['String'];
  /** Tote products available for this race. This query is only available for TOTE terminals. */
  readonly toteProducts: ReadonlyArray<ToteProduct>;
  /** The official condition of the track for this race (e.g., GOOD4, HEAVY8). */
  readonly trackCondition: TrackCondition;
  /** The timestamp of the last update to the race's information. */
  readonly updated: Scalars['TimeStamp'];
  /** The weather conditions at the track for this race. */
  readonly weather: Scalars['String'];
  /** The weight type for the race (e.g., HANDICAP, SET WEIGHT). Appears for AUS races, will only be set if it's a handicap race. */
  readonly weightType: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceBetFairMarketsArgs = {
  priceType?: InputMaybe<BetFairPriceType>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceCommentsArgs = {
  languages?: InputMaybe<ReadonlyArray<Language>>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceCompetitorsArgs = {
  runnerNumber?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceCourseMapUrlArgs = {
  source: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceDeductionSetArgs = {
  include_emergencies?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceExoticsArgs = {
  return_on_all_legs?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  type?: InputMaybe<BetType>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceExternalIdArgs = {
  source: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceGeneratedDerivativesArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RacePoolHistoryArgs = {
  priceType: PriceType;
  source: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RacePoolsArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RacePriceSetsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceResultsArgs = {
  includeInterim?: InputMaybe<Scalars['Boolean']>;
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceRule4Args = {
  deductionType?: InputMaybe<Rule4DeductionType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceSpeedMapsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceSrmPriceSelectionsArgs = {
  legs: ReadonlyArray<InputMaybe<SrmLeg>>;
  margin: Scalars['Float'];
  maxPrice: Scalars['Float'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceToteProductsArgs = {
  source: Scalars['String'];
};

export type RaceJockey = {
  readonly __typename?: 'RaceJockey';
  readonly acceptances: ReadonlyArray<Maybe<Acceptance>>;
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  readonly jockeyIdentifier?: Maybe<JockeyIdentifier>;
  readonly statistics: Statistics;
};

export type RacePool = {
  readonly __typename?: 'RacePool';
  readonly legNumber: Scalars['Int'];
  readonly source: Scalars['String'];
  readonly substituteRunnerNumber: Scalars['Int'];
  readonly tabCode: Scalars['String'];
  readonly tabDate?: Maybe<Scalars['TimeStamp']>;
  readonly tabRaceNumber: Scalars['Int'];
  readonly type: BetType;
};

export type RacePoolSubstituteUpdates = {
  readonly __typename?: 'RacePoolSubstituteUpdates';
  readonly raceId: Scalars['ID'];
  readonly runnerNumber: Scalars['Int'];
  readonly source: Scalars['String'];
  readonly type: BetType;
};

/** A notification payload, that is sent when a new market for a race is priced for the first time. */
export type RacePriced = {
  readonly __typename?: 'RacePriced';
  /** The unique identifier of the meeting where the race was priced. */
  readonly meetingId: Scalars['ID'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The data provider that has supplied the initial prices. */
  readonly source: Scalars['String'];
  /** The type of market that has just been priced (e.g., WIN, PLACE). */
  readonly type: PriceType;
};

export type RaceRunner = {
  readonly __typename?: 'RaceRunner';
  readonly acceptances: ReadonlyArray<Maybe<Acceptance>>;
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  readonly runnerData?: Maybe<RunnerData>;
  readonly runnerIdentifier?: Maybe<RunnerIdentifier>;
  readonly statistics: Statistics;
};

export type RaceSectional = {
  readonly __typename?: 'RaceSectional';
  readonly distance: Scalars['Int'];
  readonly location: Scalars['String'];
  readonly seconds: Scalars['Float'];
};

export type RaceSelectionType = {
  readonly __typename?: 'RaceSelectionType';
  readonly raceSelection: Scalars['String'];
  readonly source: Scalars['String'];
};

export type RaceSpeedMap = {
  readonly __typename?: 'RaceSpeedMap';
  readonly raceSpeedMaps: Scalars['String'];
  readonly source: Scalars['String'];
};

export enum RaceStatus {
  Abandoned = 'ABANDONED',
  BehindGates = 'BEHIND_GATES',
  Closed = 'CLOSED',
  Final = 'FINAL',
  Interim = 'INTERIM',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  PastPost = 'PAST_POST',
  Protest = 'PROTEST',
  Unknown = 'UNKNOWN'
}

/** Provides a real-time update for a change in a race's status */
export type RaceStatusUpdate = {
  readonly __typename?: 'RaceStatusUpdate';
  /** The id of the race whose status has been updated. */
  readonly id: Scalars['ID'];
  /** The new, current status of the race (e.g., 'CLOSED', 'FINAL', 'ABANDONED'). */
  readonly status: RaceStatus;
  /** The timestamp when this status update occurred. */
  readonly updated: Scalars['TimeStamp'];
};

export type RaceTrainer = {
  readonly __typename?: 'RaceTrainer';
  readonly acceptances: ReadonlyArray<Maybe<Acceptance>>;
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  readonly statistics: Statistics;
  readonly trainerIdentifier?: Maybe<TrainerIdentifier>;
};

/** Contains a payload of real-time updates for a specific race. */
export type RaceUpdate = {
  readonly __typename?: 'RaceUpdate';
  /** The updated class or grade of the race. */
  readonly class: Scalars['String'];
  /** A list of competitors with their latest updated information. */
  readonly competitors: ReadonlyArray<CompetitorUpdate>;
  /** The timestamp when the race was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The updated distance of the race in meters. */
  readonly distance: Scalars['Int'];
  /** The updated number of places paid for each-way bets. */
  readonly eachWayPlaces: Scalars['Int'];
  /** The updated reduction factor applied to each-way bets. */
  readonly eachWayReduction: Scalars['Int'];
  /** Indicates if the race is a handicap race. */
  readonly handicap: Scalars['Boolean'];
  /** The unique internal identifier for the race. */
  readonly id: Scalars['ID'];
  /** The updated official jump time of the race. */
  readonly jumpTime: Scalars['TimeStamp'];
  /** The updated information for the meeting this race belongs to. */
  readonly meeting: MeetingUpdate;
  /** The official name of the race. */
  readonly name: Scalars['String'];
  /** The race number within the meeting. */
  readonly number: Scalars['Int'];
  /** Updated information about the tote pools for the race. */
  readonly pools?: Maybe<ReadonlyArray<RacePool>>;
  /** The updated pre-jump status of the race (e.g., GOING_BEHIND, LAST_HORSE_IN). */
  readonly preJumpStatus: PreJumpStatus;
  /** The total prize money for the race. */
  readonly prizeMoney: Scalars['Int'];
  /** The updated Sky Racing channel number broadcasting the race. */
  readonly skyChannel: Scalars['Int'];
  /** The updated scheduled start time of the race. */
  readonly startTime: Scalars['TimeStamp'];
  /** The updated current status of the race (e.g., OPEN, FINAL, ABANDONED). */
  readonly status: RaceStatus;
  /** The updated type of surface the race is run on (e.g., Turf, Synthetic). */
  readonly surfaceType: Scalars['String'];
  /** The updated condition of the track for this race (e.g., GOOD, HEAVY). */
  readonly trackCondition: TrackCondition;
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
  /** The updated weather conditions at the track. */
  readonly weather: Scalars['String'];
};

export type Rating = {
  readonly __typename?: 'Rating';
  readonly career: Scalars['Float'];
  readonly currentJockey: Scalars['Float'];
  readonly distance: Scalars['Float'];
  readonly distanceTrack: Scalars['Float'];
  readonly dry: Scalars['Float'];
  readonly firm: Scalars['Float'];
  readonly firstUp: Scalars['Float'];
  readonly fourthUp: Scalars['Float'];
  readonly good: Scalars['Float'];
  readonly group1: Scalars['Float'];
  readonly group2: Scalars['Float'];
  readonly group3: Scalars['Float'];
  readonly handicap: Scalars['Float'];
  readonly heavy: Scalars['Float'];
  readonly jumps: Scalars['Float'];
  readonly listed: Scalars['Float'];
  readonly night: Scalars['Float'];
  readonly preparation: Scalars['Float'];
  readonly price: Scalars['Float'];
  readonly secondUp: Scalars['Float'];
  readonly soft: Scalars['Float'];
  readonly synthetic: Scalars['Float'];
  readonly thirdUp: Scalars['Float'];
  readonly track: Scalars['Float'];
  readonly unadjusted: Scalars['Float'];
  readonly weightForAge: Scalars['Float'];
  readonly wet: Scalars['Float'];
};

export type Recent = {
  readonly __typename?: 'Recent';
  /**
   * A summary of the runner's last 10 starts (most recent on the right).
   *
   * Each character represents a race outcome:
   *
   * - `x`   → The run occurred after a spell.
   * - `-`   → The run either failed to finish or the runner was disqualified.
   * - `0`   → The runner finished 10th place or worse.
   * - `1-9` → The runner's actual finishing position (1st to 9th).
   * - `?`   → The finishing position is unknown (FinishPosition is null, possible data error).
   */
  readonly last10Starts?: Maybe<Scalars['String']>;
  /** Number of times the runner finished 1st in the last 4 starts. */
  readonly numberOfFirstsInLast4?: Maybe<Scalars['Int']>;
  /** Number of times the runner finished 1st in the last 10 starts. */
  readonly numberOfFirstsInLast10?: Maybe<Scalars['Int']>;
  /** Number of times the runner finished in a placing position (2nd or 3rd) in the last 4 starts. */
  readonly numberOfPlacesInLast4?: Maybe<Scalars['Int']>;
  /** Number of times the runner finished in a placing position (2nd or 3rd) in the last 10 starts. */
  readonly numberOfPlacesInLast10?: Maybe<Scalars['Int']>;
  /** Current streak of consecutive races with a placing finish (1st, 2nd, or 3rd). */
  readonly placingStreak?: Maybe<Scalars['Int']>;
  /** Current streak of consecutive wins (1st place finishes). */
  readonly winningStreak?: Maybe<Scalars['Int']>;
};

export type Restrictions = {
  readonly __typename?: 'Restrictions';
  readonly age: Scalars['String'];
  readonly jockey: Scalars['String'];
  readonly sex: Scalars['String'];
  readonly weight: Scalars['String'];
};

export type ResultDeduction = {
  readonly __typename?: 'ResultDeduction';
  readonly DeductionBetType: Scalars['String'];
  readonly DeductionTime: Scalars['String'];
  readonly MarketType: Scalars['String'];
  readonly amount: Scalars['Float'];
  readonly tabNo: Scalars['String'];
  readonly type: BetType;
};

export type ResultDividend = {
  readonly __typename?: 'ResultDividend';
  readonly carriedOverDividendNumbers: Scalars['String'];
  readonly dividend: Scalars['Float'];
  readonly dividendCombinations: Scalars['String'];
  readonly dividendNumbers: ReadonlyArray<Scalars['Int']>;
  readonly jackpot: Scalars['Float'];
  readonly poolSize: Scalars['Int'];
  readonly status: ResultStatus;
  readonly type: BetType;
};

export type ResultPosition = {
  readonly __typename?: 'ResultPosition';
  /** Unavailable in subscription */
  readonly competitor: Competitor;
  readonly margin?: Maybe<Scalars['Float']>;
  readonly position: Scalars['Int'];
  readonly resultSet: ResultSet;
  readonly tabNo: Scalars['Int'];
};

export type ResultSet = {
  readonly __typename?: 'ResultSet';
  readonly created: Scalars['TimeStamp'];
  readonly deductions: ReadonlyArray<ResultDeduction>;
  readonly dividends: ReadonlyArray<ResultDividend>;
  readonly positions: ReadonlyArray<ResultPosition>;
  /** Unavailable in subscription */
  readonly race: Race;
  readonly raceId: Scalars['ID'];
  readonly source: Scalars['String'];
  readonly status: ResultStatus;
  readonly updated: Scalars['TimeStamp'];
};

export enum ResultStatus {
  Abandoned = 'ABANDONED',
  Final = 'FINAL',
  Interim = 'INTERIM',
  Partialpay = 'PARTIALPAY',
  Pending = 'PENDING',
  Protest = 'PROTEST',
  Reresult = 'RERESULT'
}

export type ReturnOnInvestment = {
  readonly __typename?: 'ReturnOnInvestment';
  readonly absolute?: Maybe<Scalars['Float']>;
  readonly percentage?: Maybe<Scalars['Float']>;
  readonly roundedAbsolute?: Maybe<Scalars['Float']>;
  readonly roundedPercentage?: Maybe<Scalars['Float']>;
  readonly roundedTotalStake?: Maybe<Scalars['Float']>;
  readonly totalStake?: Maybe<Scalars['Float']>;
};

export type Rule4 = {
  readonly __typename?: 'Rule4';
  readonly DeductionType: Scalars['String'];
  readonly Deductions: ReadonlyArray<DeductionRule4>;
  readonly MarketID?: Maybe<Scalars['String']>;
  readonly Source: Scalars['String'];
};

export enum Rule4DeductionType {
  Derivative = 'Derivative',
  Race = 'Race'
}

export type Rule4Update = {
  readonly __typename?: 'Rule4Update';
  readonly DeductionType: Scalars['String'];
  readonly Deductions: ReadonlyArray<DeductionRule4>;
  readonly MarketID?: Maybe<Scalars['String']>;
  readonly RaceID: Scalars['String'];
  readonly Source: Scalars['String'];
};

export type Runner = {
  readonly __typename?: 'Runner';
  readonly competitorsConnection: RunnerCompetitorsConnection;
  readonly id: Scalars['ID'];
};


export type RunnerCompetitorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type RunnerCompetitorEdge = {
  readonly __typename?: 'RunnerCompetitorEdge';
  readonly cursor: Scalars['ID'];
  readonly node?: Maybe<Competitor>;
};

export type RunnerCompetitorsConnection = {
  readonly __typename?: 'RunnerCompetitorsConnection';
  readonly competitors?: Maybe<ReadonlyArray<Competitor>>;
  readonly edges?: Maybe<ReadonlyArray<RunnerCompetitorEdge>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly totalCount: Scalars['Int'];
};

export type RunnerData = {
  readonly __typename?: 'RunnerData';
  readonly owners: Scalars['String'];
  readonly sex: Scalars['String'];
};

export type RunnerForm = {
  readonly __typename?: 'RunnerForm';
  readonly ageRestriction: AgeRestriction;
  readonly barrier: Scalars['Int'];
  readonly class: Scalars['String'];
  readonly date: Scalars['TimeStamp'];
  readonly distance: Scalars['Int'];
  readonly elapsedTime: Scalars['Int'];
  readonly equipments?: Maybe<ReadonlyArray<ValueDescriptionItem>>;
  readonly failedToFinishReason: Scalars['String'];
  readonly finishingPosition: Scalars['Int'];
  readonly firstSplitSeconds: Scalars['Float'];
  readonly fractions?: Maybe<ReadonlyArray<Fraction>>;
  readonly fullAgeDays: Scalars['Int'];
  readonly fullAgeMonths: Scalars['Int'];
  readonly fullAgeYears: Scalars['Int'];
  readonly gbsMeetingId: Scalars['String'];
  readonly gearChanges: Scalars['String'];
  readonly handicapMetres: Scalars['Int'];
  readonly inRun: Scalars['String'];
  readonly isJumpout: Scalars['Boolean'];
  readonly isJumps: Scalars['Boolean'];
  readonly isMobileStart: Scalars['Boolean'];
  readonly isTrial: Scalars['Boolean'];
  readonly jockey: Scalars['String'];
  readonly jockeyGlobalId: Scalars['ID'];
  readonly lastMileSeconds: Scalars['Float'];
  readonly limitWeight: Scalars['Float'];
  readonly margin: Scalars['Float'];
  readonly maximumClaimPrice: Scalars['Float'];
  readonly medications?: Maybe<ReadonlyArray<ValueDescriptionItem>>;
  readonly midPrice: Scalars['Float'];
  readonly mileRateSeconds: Scalars['Float'];
  readonly minimumClaimPrice: Scalars['Float'];
  readonly openingPrice: Scalars['Float'];
  readonly placeGetters?: Maybe<ReadonlyArray<FormPlaceGetter>>;
  readonly pointOfCalls?: Maybe<ReadonlyArray<PointOfCall>>;
  readonly prizeMoneyWon: Scalars['Float'];
  readonly prizeMoneyWonThisRace: Scalars['Float'];
  readonly prizeTotal: Scalars['Int'];
  readonly raceBenchMark: Scalars['Float'];
  readonly raceGroup: Scalars['Int'];
  readonly raceId: Scalars['String'];
  readonly raceName: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly raceSectionals?: Maybe<ReadonlyArray<RaceSectional>>;
  readonly railDistance: Scalars['Int'];
  readonly ratingUnadjusted: Scalars['Float'];
  readonly row: Scalars['Int'];
  readonly runUpDistance: Scalars['Int'];
  readonly runner: Scalars['String'];
  readonly runnerGlobalId: Scalars['ID'];
  readonly sexRestriction: SexRestriction;
  readonly speed: Scalars['Int'];
  readonly standardisedAge: Scalars['Int'];
  readonly startCount: Scalars['Int'];
  readonly starters: Scalars['Int'];
  readonly startingPrice: Scalars['Float'];
  readonly stewardsComment: Scalars['String'];
  readonly tabNumber: Scalars['Int'];
  readonly track: Scalars['String'];
  readonly trackAbbr: Scalars['String'];
  readonly trackCondition: Scalars['String'];
  readonly trackCountry: Scalars['String'];
  readonly trackRating: Scalars['Int'];
  readonly trackState: Scalars['String'];
  readonly trackSurface: Scalars['String'];
  readonly trainer: Scalars['String'];
  readonly trainerGlobalId: Scalars['ID'];
  readonly universalScale: Scalars['String'];
  /** Only available on V2 */
  readonly videoDetails?: Maybe<ReadonlyArray<VideoDetails>>;
  readonly weight: Scalars['Float'];
};


export type RunnerFormPlaceGettersArgs = {
  finishingPositions?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type RunnerIdentifier = {
  readonly __typename?: 'RunnerIdentifier';
  /** ISO 3166-1 alpha-3 country code */
  readonly countryOfBirth: Scalars['String'];
  readonly dam: Scalars['String'];
  readonly dob: Scalars['TimeStamp'];
  readonly globalId: Scalars['ID'];
  readonly meetingType: Scalars['String'];
  readonly name: Scalars['String'];
  readonly sire: Scalars['String'];
};

export type RunnerResult = {
  readonly __typename?: 'RunnerResult';
  readonly runnerIdentifier: RunnerIdentifier;
  readonly sourceRunners: ReadonlyArray<Maybe<RunnerIdentifier>>;
  readonly targetRunner: RunnerIdentifier;
};

export type ScratchedRunnerRule4 = {
  readonly __typename?: 'ScratchedRunnerRule4';
  readonly Deduction: Scalars['Float'];
  readonly Name: Scalars['String'];
  readonly Number: Scalars['Int'];
  readonly Price: Scalars['Float'];
};

/** A notification payload that is sent when a competitor is scratched (withdrawn) from a race. */
export type Scratching = {
  readonly __typename?: 'Scratching';
  /** The unique identifier of the meeting where the scratching occurred. */
  readonly meetingId: Scalars['ID'];
  /** The unique identifier of the race from which the competitor was scratched. */
  readonly raceId: Scalars['ID'];
  /** The name of the race. */
  readonly raceName: Scalars['String'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The name of the competitor that was scratched. */
  readonly runnerName: Scalars['String'];
  /** The runner number of the competitor that was scratched. */
  readonly runnerNumber: Scalars['Int'];
  /** The type of scratching, indicating when the withdrawal occurred (e.g., SCRATCHED, LATESCRATCHING). */
  readonly scratchingType: ScratchingType;
};

export enum ScratchingType {
  Latescratching = 'LATESCRATCHING',
  Scratched = 'SCRATCHED',
  Starter = 'STARTER'
}

export type SexRestriction = {
  readonly __typename?: 'SexRestriction';
  readonly restrictedTo?: Maybe<ReadonlyArray<Scalars['String']>>;
};

/** Represents a data provider. */
export type Source = {
  readonly __typename?: 'Source';
  /** The unique identifier for the data provider. This is the value used when filtering queries by source. */
  readonly code: Scalars['String'];
  /** An internal system identifier for the source, generally used for internal mapping. */
  readonly gbsCode: Scalars['String'];
  /** A flag that is `true` if the provider offers prices and betting odds. */
  readonly isPriceSource: Scalars['Boolean'];
  /** Human readable name of the provider, suitable for display. */
  readonly name: Scalars['String'];
  readonly platformType: PlatformType;
};

export type SourceComment = {
  readonly __typename?: 'SourceComment';
  readonly comment: Scalars['String'];
  readonly language: Language;
  readonly source: Scalars['String'];
  readonly status: Status;
};

export type SourceId = {
  readonly __typename?: 'SourceId';
  readonly id: Scalars['String'];
  readonly source: Scalars['String'];
};

export type Spell = {
  readonly __typename?: 'Spell';
  readonly firstUp?: Maybe<PlacingStats>;
  readonly fourthUp?: Maybe<PlacingStats>;
  readonly secondUp?: Maybe<PlacingStats>;
  readonly thirdUp?: Maybe<PlacingStats>;
};

export type SportCategory = {
  readonly __typename?: 'SportCategory';
  readonly competitions?: Maybe<ReadonlyArray<SportCompetition>>;
  readonly country: Scalars['String'];
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
  readonly sport_type: SportType;
};

export type SportCompetition = {
  readonly __typename?: 'SportCompetition';
  readonly category: SportCategory;
  readonly description: Scalars['String'];
  readonly events?: Maybe<ReadonlyArray<SportEvent>>;
  readonly id: Scalars['ID'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
};


export type SportCompetitionEventsArgs = {
  endDate?: InputMaybe<Scalars['Time']>;
  startDate?: InputMaybe<Scalars['Time']>;
};

export type SportEvent = {
  readonly __typename?: 'SportEvent';
  readonly competition: SportCompetition;
  /** @deprecated countOfMarkets is deprecated, a value of 1 will indicate if markets are present, and 0 if no markets are present */
  readonly countOfMarkets: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly markets?: Maybe<ReadonlyArray<SportMarket>>;
  readonly marketsConnection: EventMarketsConnection;
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly round: Scalars['String'];
  readonly season: Scalars['String'];
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
  readonly start_date: Scalars['TimeStamp'];
  readonly status: Scalars['String'];
  readonly teams?: Maybe<ReadonlyArray<Maybe<SportTeam>>>;
};


export type SportEventMarketsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  marketTypes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  sources?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
};


export type SportEventMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type SportEventUpdate = {
  readonly __typename?: 'SportEventUpdate';
  readonly competition_id: Scalars['ID'];
  readonly created: Scalars['TimeStamp'];
  readonly description: Scalars['String'];
  readonly enabled: Scalars['Boolean'];
  readonly event_id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly round: Scalars['String'];
  readonly season: Scalars['String'];
  readonly start_time: Scalars['TimeStamp'];
  readonly status: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportExternalSource = {
  readonly __typename?: 'SportExternalSource';
  readonly data_source_id: Scalars['Int'];
  readonly data_source_name: Scalars['String'];
  readonly external_id: Scalars['String'];
};

export type SportMarket = {
  readonly __typename?: 'SportMarket';
  readonly description: Scalars['String'];
  readonly event_id: Scalars['ID'];
  readonly has_trade_flags: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly is_in_play: Scalars['Boolean'];
  readonly is_pre_match: Scalars['Boolean'];
  readonly is_rolling_line: Scalars['Boolean'];
  readonly line: Scalars['Float'];
  readonly margin: Scalars['Float'];
  readonly market_type: Scalars['String'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly score?: Maybe<SportScore>;
  readonly selections?: Maybe<ReadonlyArray<SportSelection>>;
  readonly selectionsConnection?: Maybe<MarketSelectionsConnection>;
  readonly sort_order?: Maybe<Scalars['String']>;
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
  readonly status: Scalars['String'];
};


export type SportMarketSelectionsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sources?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
};


export type SportMarketSelectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  sources?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type SportMarketResult = {
  readonly __typename?: 'SportMarketResult';
  readonly event_id: Scalars['ID'];
  readonly market_id: Scalars['ID'];
  readonly selections?: Maybe<ReadonlyArray<SportResult>>;
};

export type SportMarketUpdate = {
  readonly __typename?: 'SportMarketUpdate';
  readonly created: Scalars['TimeStamp'];
  readonly description: Scalars['String'];
  readonly enabled: Scalars['Boolean'];
  readonly event_id: Scalars['ID'];
  readonly has_trade_flags: Scalars['Boolean'];
  readonly is_in_play: Scalars['Boolean'];
  readonly is_pre_match: Scalars['Boolean'];
  readonly is_rolling_line: Scalars['Boolean'];
  readonly line: Scalars['Float'];
  readonly margin: Scalars['Float'];
  readonly market_id: Scalars['ID'];
  readonly market_type: Scalars['String'];
  readonly name: Scalars['String'];
  readonly score?: Maybe<SportScore>;
  readonly selections?: Maybe<ReadonlyArray<Maybe<SportSelectionUpdate>>>;
  readonly sort_order?: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportPlayer = {
  readonly __typename?: 'SportPlayer';
  readonly first_name: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly last_name: Scalars['String'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
};

export type SportPrice = {
  readonly __typename?: 'SportPrice';
  readonly age: Scalars['Int'];
  readonly decimal_price: Scalars['Float'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly denominator: Scalars['Int'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly fractional_price?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly modified_date: Scalars['TimeStamp'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly numerator: Scalars['Int'];
  readonly source: Scalars['String'];
};

export type SportPriceUpdate = {
  readonly __typename?: 'SportPriceUpdate';
  readonly decimal_price: Scalars['Float'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly denominator: Scalars['Int'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly fractional_price?: Maybe<Scalars['String']>;
  readonly market_id: Scalars['ID'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly numerator: Scalars['Int'];
  readonly selection_id: Scalars['ID'];
  readonly source: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportResult = {
  readonly __typename?: 'SportResult';
  readonly created: Scalars['TimeStamp'];
  readonly decimal_price: Scalars['Float'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly denominator: Scalars['Int'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly fractional_price?: Maybe<Scalars['String']>;
  readonly line: Scalars['Float'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly numerator: Scalars['Int'];
  readonly outcome: Scalars['String'];
  readonly score?: Maybe<SportScore>;
  readonly selection_id: Scalars['ID'];
  readonly source: Scalars['String'];
  readonly status: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportResultUpdate = {
  readonly __typename?: 'SportResultUpdate';
  readonly created: Scalars['TimeStamp'];
  readonly decimal_price: Scalars['Float'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly denominator: Scalars['Int'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly fractional_price?: Maybe<Scalars['String']>;
  readonly line: Scalars['Float'];
  readonly market_id: Scalars['ID'];
  /** @deprecated fractional prices are being deprecated, use decimal price instead */
  readonly numerator: Scalars['Int'];
  readonly outcome: Scalars['String'];
  readonly score?: Maybe<SportScore>;
  readonly selection_id: Scalars['ID'];
  readonly source: Scalars['String'];
  readonly status: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportResultUpdateV2 = {
  readonly __typename?: 'SportResultUpdateV2';
  readonly created: Scalars['TimeStamp'];
  readonly decimal_price: Scalars['Float'];
  readonly line: Scalars['Float'];
  readonly outcome: Scalars['String'];
  readonly score?: Maybe<SportScore>;
  readonly selection_id: Scalars['ID'];
  readonly status: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportResultsUpdate = {
  readonly __typename?: 'SportResultsUpdate';
  readonly event_id: Scalars['ID'];
  readonly market_id: Scalars['ID'];
  readonly results?: Maybe<ReadonlyArray<SportResultUpdateV2>>;
  readonly source: Scalars['String'];
};

export type SportScore = {
  readonly __typename?: 'SportScore';
  readonly away: Scalars['Float'];
  readonly home: Scalars['Float'];
  readonly total: Scalars['Float'];
};

export type SportSelection = {
  readonly __typename?: 'SportSelection';
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly line: Scalars['Float'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly outcome?: Maybe<Scalars['String']>;
  readonly prices?: Maybe<ReadonlyArray<SportPrice>>;
  readonly resulted: Scalars['Boolean'];
  readonly sort_order?: Maybe<Scalars['String']>;
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
  readonly status: Scalars['String'];
};


export type SportSelectionPricesArgs = {
  sources?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type SportSelectionUpdate = {
  readonly __typename?: 'SportSelectionUpdate';
  readonly created: Scalars['TimeStamp'];
  readonly enabled: Scalars['Boolean'];
  readonly line: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly outcome?: Maybe<Scalars['String']>;
  readonly resulted: Scalars['Boolean'];
  readonly selection_id: Scalars['ID'];
  readonly sort_order?: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type SportSource = {
  readonly __typename?: 'SportSource';
  readonly description: Scalars['String'];
  readonly id: Scalars['Int'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly trusted: Scalars['Boolean'];
};

export type SportTeam = {
  readonly __typename?: 'SportTeam';
  readonly category: SportCategory;
  readonly id: Scalars['ID'];
  readonly modified_date: Scalars['TimeStamp'];
  readonly name: Scalars['String'];
  readonly players?: Maybe<ReadonlyArray<SportPlayer>>;
  readonly position?: Maybe<Scalars['String']>;
  readonly sources?: Maybe<ReadonlyArray<Maybe<SportExternalSource>>>;
};

export type SportType = {
  readonly __typename?: 'SportType';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
};

export type SrmLeg = {
  readonly positions: ReadonlyArray<Scalars['Int']>;
  readonly runnerNumber: Scalars['Int'];
};

export type SrmListPrice = {
  readonly __typename?: 'SrmListPrice';
  readonly runnerNumber: Scalars['Int'];
  readonly top2Price: Scalars['Float'];
  readonly top3Price: Scalars['Float'];
  readonly top4Price: Scalars['Float'];
  readonly winPrice: Scalars['Float'];
};

export type SrmSelectionPrice = {
  readonly __typename?: 'SrmSelectionPrice';
  readonly margin: Scalars['Float'];
  readonly price: Scalars['Float'];
};

export type Statistics = {
  readonly __typename?: 'Statistics';
  readonly all?: Maybe<PlacingStats>;
  readonly barrierRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly campaign?: Maybe<PlacingStats>;
  readonly career?: Maybe<Career>;
  readonly conditionPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly distanceAndConditionPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly distancePlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly distanceRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly fieldSizeRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly firstUp?: Maybe<PlacingStats>;
  readonly fourthUp?: Maybe<PlacingStats>;
  readonly jockeyPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /**
   * A string representing the finishing positions of the competitor's last 10 races, with the most recent start appearing on the right. Each character in the string is a code for the outcome of a race:
   *
   * - **`1-9`**: Represents the horse's exact finishing position.
   * - **`0`**: Indicates the horse finished in 10th place or worse.
   * - **`x`**: Signifies the race occurred after a "spell".
   * - **`-`**: Means the horse either failed to finish or was disqualified.
   * - **`?`**: Indicates the finishing position is unknown, possibly due to a data issue.
   */
  readonly last10Starts?: Maybe<Scalars['String']>;
  readonly lastSeason?: Maybe<PlacingStats>;
  readonly numberOfFirstsInLast4?: Maybe<Scalars['Int']>;
  readonly numberOfFirstsInLast10?: Maybe<Scalars['Int']>;
  readonly numberOfPlacesInLast4?: Maybe<Scalars['Int']>;
  readonly numberOfPlacesInLast10?: Maybe<Scalars['Int']>;
  readonly performances?: Maybe<Performances>;
  readonly placingStreak?: Maybe<Scalars['Int']>;
  readonly raceAgeRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly recent?: Maybe<Recent>;
  readonly secondUp?: Maybe<PlacingStats>;
  readonly surfacePlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly thirdUp?: Maybe<PlacingStats>;
  readonly thisCampaign?: Maybe<PlacingStats>;
  readonly thisSeason?: Maybe<PlacingStats>;
  readonly trackAndDistancePlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly trackPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly trainerAndJockeyPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly trainerPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly weightPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  readonly weightRangePlaces?: Maybe<ReadonlyArray<DecimalRangedPlacingStats>>;
  readonly winningStreak?: Maybe<Scalars['Int']>;
};

export enum Status {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type Subscription = {
  readonly __typename?: 'Subscription';
  /** Only available to BetFair subscribers. */
  readonly betFairUpdates: BetFairMarket;
  /** Streams real-time comment updates for a given race. */
  readonly commentUpdates: CommentUpdate;
  /** Regulated VIC and SOD deductions. */
  readonly deductionUpdates: DeductionSet;
  /** Streams updates for exotic bet types, such as pools and dividends, for a specific race. */
  readonly exoticUpdates: ExoticUpdate;
  /** Subscribes to real-time updates for a specific futures event. */
  readonly futureEventUpdates: FuturesV2EventUpdate;
  /** Subscription is only for price manager clients, streams generated derivatives for linked price manager */
  readonly generatedDerivative: Derivative;
  /** Only for price manager clients, streams generated prices for linked price manager */
  readonly generatedPrice: PriceSet;
  /** Streams real-time updates for live form data for a given meeting. */
  readonly liveFormUpdated: LiveFormUpdated;
  /** Provides real-time updates on the pre-jump status of a race (e.g., going behind, last horse in). */
  readonly preJumpRaceStatusUpdated: PreJumpRaceStatusUpdate;
  /** Streams predicted rating updates for a given race. */
  readonly predictedRatingUpdates: PredictedRatingUpdate;
  /** Streams live price updates for a given race, with options to filter by `sources` and `sourceTypes`. */
  readonly priceUpdates: PriceSet;
  /** Discovery for when a race is newly priced */
  readonly racePriced: RacePriced;
  /** Streams real-time updates to the status of a race (e.g., OPEN, CLOSED, ABANDONED). */
  readonly raceStatusUpdated: RaceStatusUpdate;
  /** Subscribes to updates for a specific race, providing real-time changes to race details. */
  readonly raceUpdated: RaceUpdate;
  /** Streams competitors' RACELAB Insights at a race level */
  readonly racelabInsights: RacelabInsightsUpdated;
  /** Provides real-time race results, including positions and dividends, as they become available. */
  readonly results: ResultSet;
  /** Rule 4 deductions are UK specific and for UK clients only. */
  readonly rule4Updates: Rule4Update;
  /** Provides real-time notifications when a runner is scratched from a race. */
  readonly scratching: Scratching;
  /** Provides real-time updates for sporting events, such as changes in start times or status. */
  readonly sportEventUpdates: SportEventUpdate;
  /** Streams updates for sports markets, including changes in status or margins. */
  readonly sportMarketUpdates: SportMarketUpdate;
  /** Provides to real-time price updates for sports markets. */
  readonly sportPriceUpdates: SportPriceUpdate;
  /**
   * Subscribes to real-time results updates for sports markets.
   * @deprecated individual results are being phased out, use sportResultsUpdates instead
   */
  readonly sportResultUpdates: SportResultUpdate;
  /** Subscribes to real-time results updates for sports markets. */
  readonly sportResultsUpdates: SportResultsUpdate;
  /** Notifies you of substitute runner updates for a given race. */
  readonly substituteUpdates: RacePoolSubstituteUpdates;
  /** This subscription is only available for TOTE terminals */
  readonly toteProductUpdates: ToteProductUpdate;
  /** Streams real-time results and dividends for virtual races. */
  readonly virtualRaceResultUpdates: VirtualRaceResult;
  /** Subscribes to real-time updates on selections and odds for virtual races. */
  readonly virtualRaceSelectionUpdates: VirtualSelections;
  /** Provides real-time updates on the status of virtual races. */
  readonly virtualRaceStatusUpdates: VirtualRaceStatusUpdate;
  /** Provides real-time updates for virtual races from a specific source. */
  readonly virtualRaceUpdates: VirtualRace;
};


export type SubscriptionBetFairUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  types?: InputMaybe<ReadonlyArray<BetFairPriceType>>;
};


export type SubscriptionCommentUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionDeductionUpdatesArgs = {
  include_emergencies?: InputMaybe<Scalars['Boolean']>;
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionExoticUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  type?: InputMaybe<BetType>;
};


export type SubscriptionFutureEventUpdatesArgs = {
  eventId: Scalars['ID'];
};


export type SubscriptionGeneratedDerivativeArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionGeneratedPriceArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionLiveFormUpdatedArgs = {
  meetingId?: InputMaybe<Scalars['ID']>;
  source: Scalars['String'];
};


export type SubscriptionPredictedRatingUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionPriceUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sourceTypes?: InputMaybe<ReadonlyArray<InputSourceType>>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionRaceUpdatedArgs = {
  dated?: InputMaybe<Scalars['Time']>;
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionResultsArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionRule4UpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionSportEventUpdatesArgs = {
  eventIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


export type SubscriptionSportMarketUpdatesArgs = {
  marketIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  status?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionSportPriceUpdatesArgs = {
  marketIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


export type SubscriptionSportResultUpdatesArgs = {
  marketIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  status?: InputMaybe<Scalars['String']>;
};


export type SubscriptionSportResultsUpdatesArgs = {
  marketIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  status?: InputMaybe<Scalars['String']>;
};


export type SubscriptionSubstituteUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionToteProductUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionVirtualRaceResultUpdatesArgs = {
  betTypes?: InputMaybe<ReadonlyArray<VirtualBetType>>;
  source: Scalars['String'];
};


export type SubscriptionVirtualRaceSelectionUpdatesArgs = {
  betTypes?: InputMaybe<ReadonlyArray<VirtualBetType>>;
  source: Scalars['String'];
};


export type SubscriptionVirtualRaceStatusUpdatesArgs = {
  source: Scalars['String'];
};


export type SubscriptionVirtualRaceUpdatesArgs = {
  source: Scalars['String'];
};

export type Summary = {
  readonly __typename?: 'Summary';
  readonly byBarrier?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly byDistance?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly byFieldSize?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly byRaceAge?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  readonly byWeight?: Maybe<ReadonlyArray<DecimalRangedPlacingStats>>;
};

export enum TotePoolType {
  Choose6 = 'CHOOSE6',
  Double = 'DOUBLE',
  Doubletrio = 'DOUBLETRIO',
  Exact6 = 'EXACT6',
  Exacta = 'EXACTA',
  G75 = 'G75',
  Grandslam = 'GRANDSLAM',
  Jackpot = 'JACKPOT',
  Nfl5 = 'NFL5',
  Omni = 'OMNI',
  Onetwothree = 'ONETWOTHREE',
  Pentafecta = 'PENTAFECTA',
  Pick3 = 'PICK3',
  Pick4 = 'PICK4',
  Pick5 = 'PICK5',
  Pick6 = 'PICK6',
  Pick7 = 'PICK7',
  Pick8 = 'PICK8',
  Pick9 = 'PICK9',
  Pick10 = 'PICK10',
  Pickx = 'PICKX',
  Place = 'PLACE',
  Placepot = 'PLACEPOT',
  Pmu2Sur4 = 'PMU2SUR4',
  Pmu4Plus = 'PMU4PLUS',
  Pmu5Plus = 'PMU5PLUS',
  Pmuclassictierce = 'PMUCLASSICTIERCE',
  Pmuminimulti = 'PMUMINIMULTI',
  Pmumulti = 'PMUMULTI',
  Pmupick5 = 'PMUPICK5',
  Pmutierce = 'PMUTIERCE',
  Pmutrio = 'PMUTRIO',
  Quadpot = 'QUADPOT',
  Quinella = 'QUINELLA',
  Racingo = 'RACINGO',
  Scoop6 = 'SCOOP6',
  Show = 'SHOW',
  Sixup = 'SIXUP',
  Superfecta = 'SUPERFECTA',
  Survivor4 = 'SURVIVOR4',
  Survivor5 = 'SURVIVOR5',
  Survivor6 = 'SURVIVOR6',
  Survivor7 = 'SURVIVOR7',
  Survivor8 = 'SURVIVOR8',
  Survivor9 = 'SURVIVOR9',
  Survivor10 = 'SURVIVOR10',
  T64 = 'T64',
  T75 = 'T75',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  Tripletrio = 'TRIPLETRIO',
  V4 = 'V4',
  V5 = 'V5',
  V64 = 'V64',
  V65 = 'V65',
  V75 = 'V75',
  V86 = 'V86',
  Vpick = 'VPICK',
  Win = 'WIN',
  Winscore = 'WINSCORE'
}

export type ToteProduct = {
  readonly __typename?: 'ToteProduct';
  readonly betStyle: Scalars['String'];
  readonly betTypeId: Scalars['Int'];
  readonly id: BetType;
  readonly increment: Scalars['Float'];
  readonly maxBetAmt: Scalars['Float'];
  readonly maxBetCost: Scalars['Float'];
  readonly maxCombs: Scalars['Float'];
  readonly minBetAmt: Scalars['Float'];
  readonly minBetCost: Scalars['Float'];
  readonly minCombs: Scalars['Float'];
  readonly minimumStake: Scalars['Float'];
  readonly poolName: Scalars['String'];
  readonly poolType: TotePoolType;
  readonly races: Scalars['String'];
};

export type ToteProductUpdate = {
  readonly __typename?: 'ToteProductUpdate';
  readonly meetingId: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly source: Scalars['String'];
  readonly toteProducts: ReadonlyArray<ToteProduct>;
};

/** Represents a racing track/venue where meetings are held. */
export type Track = {
  readonly __typename?: 'Track';
  /** A short, commonly used abbreviation for the track's name. */
  readonly abbreviation: Scalars['String'];
  /** A four-character abbreviation for the track. */
  readonly abbreviationFourChar: Scalars['String'];
  /** The country where the track is located (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** The timestamp when the track was first added to the system. */
  readonly created: Scalars['TimeStamp'];
  /** The unique internal identifier for the track. */
  readonly id: Scalars['ID'];
  /** The geographical location type of the track (e.g., METRO, COUNTRY). */
  readonly location: TrackLocation;
  /** A paginated list of meetings held at this track. Can be filtered to show meetings after a specific date. */
  readonly meetingsConnection: TrackMeetingsConnection;
  /** The full, official name of the track. */
  readonly name: Scalars['String'];
  /** The state or province where the track is located. */
  readonly state: Scalars['String'];
  /** The primary racing surface of the track (e.g., Turf, Dirt). */
  readonly surface: Scalars['String'];
  /** The timestamp of the last update to the track's information. */
  readonly updated: Scalars['TimeStamp'];
};


/** Represents a racing track/venue where meetings are held. */
export type TrackMeetingsConnectionArgs = {
  afterDate?: InputMaybe<Scalars['TimeStamp']>;
  first?: InputMaybe<Scalars['Int']>;
};

export enum TrackCondition {
  Dead = 'DEAD',
  Dirt = 'DIRT',
  Easy = 'EASY',
  Fair = 'FAIR',
  Fast = 'FAST',
  Firm = 'FIRM',
  Firm1 = 'FIRM1',
  Firm2 = 'FIRM2',
  Good = 'GOOD',
  Good3 = 'GOOD3',
  Good4 = 'GOOD4',
  Heavy = 'HEAVY',
  Heavy8 = 'HEAVY8',
  Heavy9 = 'HEAVY9',
  Heavy10 = 'HEAVY10',
  Sand = 'SAND',
  Slow = 'SLOW',
  Soft = 'SOFT',
  Soft5 = 'SOFT5',
  Soft6 = 'SOFT6',
  Soft7 = 'SOFT7',
  Standard = 'STANDARD',
  StandardToFast = 'STANDARD_TO_FAST',
  StandardToSlow = 'STANDARD_TO_SLOW',
  UnknownCondition = 'UNKNOWN_CONDITION',
  VeryHeavy = 'VERY_HEAVY',
  Yielding = 'YIELDING'
}

export enum TrackLocation {
  Country = 'COUNTRY',
  LocationF = 'LOCATION_F',
  LocationG = 'LOCATION_G',
  LocationUnknown = 'LOCATION_UNKNOWN',
  LocationX = 'LOCATION_X',
  Metro = 'METRO',
  Provincial = 'PROVINCIAL'
}

export type TrackMeetingEdge = {
  readonly __typename?: 'TrackMeetingEdge';
  readonly cursor: Scalars['ID'];
  readonly node?: Maybe<Meeting>;
};

export type TrackMeetingsConnection = {
  readonly __typename?: 'TrackMeetingsConnection';
  readonly edges?: Maybe<ReadonlyArray<TrackMeetingEdge>>;
  readonly meetings?: Maybe<ReadonlyArray<Meeting>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly totalCount: Scalars['Int'];
};

/** Contains a payload of real-time updates for a specific track. */
export type TrackUpdate = {
  readonly __typename?: 'TrackUpdate';
  /** The four-character abbreviation for the track. */
  readonly abbreviationFourChar: Scalars['String'];
  /** The country where the track is located (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** The timestamp when the track was first added to the system. */
  readonly created: Scalars['TimeStamp'];
  /** The unique internal identifier for the track. */
  readonly id: Scalars['ID'];
  /** The geographical location type of the track (e.g., METRO, COUNTRY). */
  readonly location: TrackLocation;
  /** The official name of the track. */
  readonly name: Scalars['String'];
  /** The state or province where the track is located. */
  readonly state: Scalars['String'];
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
};

export type TrainerIdentifier = {
  readonly __typename?: 'TrainerIdentifier';
  readonly globalId: Scalars['ID'];
  readonly meetingType: Scalars['String'];
  readonly name: Scalars['String'];
};

export type TrainerResult = {
  readonly __typename?: 'TrainerResult';
  readonly sourceTrainers: ReadonlyArray<Maybe<TrainerIdentifier>>;
  readonly targetTrainer: TrainerIdentifier;
  readonly trainerIdentifier: TrainerIdentifier;
};

export type ValueDescriptionItem = {
  readonly __typename?: 'ValueDescriptionItem';
  readonly Description: Scalars['String'];
  readonly Value: Scalars['String'];
};

export type VideoDetails = {
  readonly __typename?: 'VideoDetails';
  readonly videoAssetId?: Maybe<Scalars['String']>;
  readonly videoId?: Maybe<Scalars['String']>;
  readonly videoProvider: Scalars['String'];
  readonly videoURL?: Maybe<Scalars['String']>;
};

export enum VirtualBetType {
  Exacta = 'EXACTA',
  H2HBestVsSecond = 'H2H_BEST_VS_SECOND',
  H2HSecondVsThird = 'H2H_SECOND_VS_THIRD',
  H2HThirdVsFourth = 'H2H_THIRD_VS_FOURTH',
  HighLow = 'HIGH_LOW',
  LastPlace = 'LAST_PLACE',
  LastThree = 'LAST_THREE',
  OddEven = 'ODD_EVEN',
  Place = 'PLACE',
  Quinella = 'QUINELLA',
  SecondPlace = 'SECOND_PLACE',
  SumFirstThree = 'SUM_FIRST_THREE',
  SumFirstTwo = 'SUM_FIRST_TWO',
  Swinger = 'SWINGER',
  ThirdPlace = 'THIRD_PLACE',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  Win = 'WIN'
}

export type VirtualBetTypeGroup = {
  readonly __typename?: 'VirtualBetTypeGroup';
  readonly betType: VirtualBetType;
  readonly selections: ReadonlyArray<VirtualSelectionEntry>;
};

export type VirtualCompetitor = {
  readonly __typename?: 'VirtualCompetitor';
  readonly created: Scalars['TimeStamp'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly racesSincePlace: Scalars['Int'];
  readonly racesSinceWin: Scalars['Int'];
  readonly runnerLastStarts: Scalars['String'];
  readonly runnerNumber: Scalars['Int'];
  readonly runnerStarRating: Scalars['Float'];
  readonly sourceCompetitorId: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type VirtualRace = {
  readonly __typename?: 'VirtualRace';
  readonly competitors: ReadonlyArray<VirtualCompetitor>;
  readonly created: Scalars['TimeStamp'];
  readonly distance: Scalars['Int'];
  readonly finishTime: Scalars['TimeStamp'];
  readonly id: Scalars['ID'];
  readonly multiplierResult: Scalars['Int'];
  readonly multiplierStake: Scalars['Int'];
  readonly multiplierValues: Scalars['String'];
  readonly name: Scalars['String'];
  readonly number: Scalars['Int'];
  readonly placePayoutPositions: Scalars['Int'];
  readonly raceStatus: VirtualRaceStatus;
  readonly raceType: VirtualRaceType;
  readonly source: Scalars['String'];
  readonly sourceRaceId: Scalars['String'];
  readonly startTime: Scalars['TimeStamp'];
  readonly updated: Scalars['TimeStamp'];
};

export type VirtualRaceResult = {
  readonly __typename?: 'VirtualRaceResult';
  readonly dividend: ReadonlyArray<VirtualResultDividend>;
  readonly position: ReadonlyArray<VirtualResultPosition>;
  readonly raceId: Scalars['ID'];
};

export enum VirtualRaceStatus {
  BettingSuspended = 'BETTING_SUSPENDED',
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  OpenForBetting = 'OPEN_FOR_BETTING',
  PartialResult = 'PARTIAL_RESULT',
  Pending = 'PENDING'
}

export type VirtualRaceStatusUpdate = {
  readonly __typename?: 'VirtualRaceStatusUpdate';
  readonly raceId: Scalars['ID'];
  readonly raceStatus: VirtualRaceStatus;
};

export enum VirtualRaceType {
  DashingDerby = 'DASHING_DERBY',
  HarnessRacing = 'HARNESS_RACING',
  PlatinumHounds = 'PLATINUM_HOUNDS',
  SteepleChase = 'STEEPLE_CHASE'
}

export type VirtualResultDividend = {
  readonly __typename?: 'VirtualResultDividend';
  readonly betType: VirtualBetType;
  readonly created: Scalars['TimeStamp'];
  readonly dividend: Scalars['Float'];
  readonly updated: Scalars['TimeStamp'];
  readonly winSelectionString: Scalars['String'];
};

export type VirtualResultPosition = {
  readonly __typename?: 'VirtualResultPosition';
  readonly competitorId: Scalars['ID'];
  readonly created: Scalars['TimeStamp'];
  readonly position: Scalars['Int'];
  readonly runnerName: Scalars['String'];
  readonly runnerNumber: Scalars['Int'];
  readonly sourceCompetitorId: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type VirtualSelectionEntry = {
  readonly __typename?: 'VirtualSelectionEntry';
  readonly created: Scalars['TimeStamp'];
  readonly odds: Scalars['Float'];
  readonly selectionString: Scalars['String'];
  readonly updated: Scalars['TimeStamp'];
};

export type VirtualSelections = {
  readonly __typename?: 'VirtualSelections';
  readonly betTypes: ReadonlyArray<VirtualBetTypeGroup>;
  readonly race_id: Scalars['ID'];
};

export type InputSourceId = {
  readonly source: Scalars['String'];
  readonly sourceId: Scalars['String'];
};

export type InputSourceRaceId = {
  readonly number?: InputMaybe<Scalars['Int']>;
  readonly source: Scalars['String'];
  readonly sourceId: Scalars['String'];
};

export type InputSourceType = {
  readonly source: Scalars['String'];
  readonly type: PriceType;
};

export type MeetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type MeetingQuery = { readonly __typename?: 'Query', readonly meeting?: { readonly __typename?: 'Meeting', readonly id: string, readonly type: MeetingType, readonly races: ReadonlyArray<{ readonly __typename?: 'Race', readonly id: string, readonly number: number, readonly status: RaceStatus, readonly startTime: string }>, readonly track: { readonly __typename?: 'Track', readonly id: string, readonly name: string, readonly surface: string, readonly country: string } } | null };

export type MeetingsDatedQueryVariables = Exact<{
  firstRaceFrom?: InputMaybe<Scalars['Time']>;
  to?: InputMaybe<Scalars['Time']>;
}>;


export type MeetingsDatedQuery = { readonly __typename?: 'Query', readonly meetingsDated: ReadonlyArray<{ readonly __typename?: 'Meeting', readonly id: string, readonly type: MeetingType, readonly track: { readonly __typename?: 'Track', readonly id: string, readonly name: string, readonly surface: string, readonly country: string }, readonly races: ReadonlyArray<{ readonly __typename?: 'Race', readonly id: string, readonly number: number, readonly status: RaceStatus, readonly startTime: string, readonly meeting: { readonly __typename?: 'Meeting', readonly id: string } }> }> };

export type RaceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  silksSize: Scalars['Int'];
}>;


export type RaceQuery = { readonly __typename?: 'Query', readonly race?: { readonly __typename?: 'Race', readonly id: string, readonly number: number, readonly name: string, readonly distance: number, readonly startTime: string, readonly class: string, readonly status: RaceStatus, readonly prizeMoney: number, readonly trackCondition: TrackCondition, readonly weather: string, readonly surfaceType: string, readonly meeting: { readonly __typename?: 'Meeting', readonly id: string, readonly type: MeetingType, readonly externalIDs?: ReadonlyArray<{ readonly __typename?: 'SourceId', readonly id: string, readonly source: string } | null> | null, readonly track: { readonly __typename?: 'Track', readonly id: string, readonly country: string, readonly name: string, readonly state: string } }, readonly priceSets: ReadonlyArray<{ readonly __typename?: 'PriceSet', readonly source: string, readonly raceNumber: number, readonly type: PriceType, readonly poolSize: number, readonly prices: ReadonlyArray<{ readonly __typename?: 'Price', readonly source: string, readonly tabNo: number, readonly price: number, readonly type: PriceType }> }>, readonly results: ReadonlyArray<{ readonly __typename?: 'ResultSet', readonly source: string, readonly positions: ReadonlyArray<{ readonly __typename?: 'ResultPosition', readonly tabNo: number, readonly position: number, readonly margin?: number | null }>, readonly dividends: ReadonlyArray<{ readonly __typename?: 'ResultDividend', readonly dividendNumbers: ReadonlyArray<number>, readonly dividend: number, readonly type: BetType, readonly poolSize: number }> }>, readonly competitors: ReadonlyArray<{ readonly __typename?: 'Competitor', readonly tabNo: number, readonly barrier: number, readonly name: string, readonly scratched: boolean, readonly silksURL: string, readonly prices: ReadonlyArray<{ readonly __typename?: 'Price', readonly price: number, readonly type: PriceType, readonly tabNo: number, readonly source: string }>, readonly flucs: ReadonlyArray<{ readonly __typename?: 'PriceFluc', readonly price: number, readonly time: string }> }> } | null };

export type RaceUpdatedSubscriptionVariables = Exact<{
  raceId?: InputMaybe<Scalars['ID']>;
}>;


export type RaceUpdatedSubscription = { readonly __typename?: 'Subscription', readonly raceUpdated: { readonly __typename?: 'RaceUpdate', readonly id: string, readonly startTime: string, readonly status: RaceStatus, readonly surfaceType: string, readonly competitors: ReadonlyArray<{ readonly __typename?: 'CompetitorUpdate', readonly scratched: boolean, readonly tabNo: number }> } };


export const MeetingDocument = gql`
    query meeting($id: ID) {
  meeting(id: $id) {
    id
    type
    races {
      id
      number
      status
      startTime
    }
    track {
      id
      name
      surface
      country
    }
  }
}
    `;

/**
 * __useMeetingQuery__
 *
 * To run a query within a React component, call `useMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeetingQuery(baseOptions?: Apollo.QueryHookOptions<MeetingQuery, MeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingQuery, MeetingQueryVariables>(MeetingDocument, options);
      }
export function useMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingQuery, MeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingQuery, MeetingQueryVariables>(MeetingDocument, options);
        }
export type MeetingQueryHookResult = ReturnType<typeof useMeetingQuery>;
export type MeetingLazyQueryHookResult = ReturnType<typeof useMeetingLazyQuery>;
export type MeetingQueryResult = Apollo.QueryResult<MeetingQuery, MeetingQueryVariables>;
export const MeetingsDatedDocument = gql`
    query meetingsDated($firstRaceFrom: Time, $to: Time) {
  meetingsDated(firstRaceFrom: $firstRaceFrom, to: $to) {
    id
    track {
      id
      name
      surface
      country
    }
    races {
      id
      number
      status
      startTime
      meeting {
        id
      }
    }
    type
  }
}
    `;

/**
 * __useMeetingsDatedQuery__
 *
 * To run a query within a React component, call `useMeetingsDatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsDatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsDatedQuery({
 *   variables: {
 *      firstRaceFrom: // value for 'firstRaceFrom'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMeetingsDatedQuery(baseOptions?: Apollo.QueryHookOptions<MeetingsDatedQuery, MeetingsDatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingsDatedQuery, MeetingsDatedQueryVariables>(MeetingsDatedDocument, options);
      }
export function useMeetingsDatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingsDatedQuery, MeetingsDatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingsDatedQuery, MeetingsDatedQueryVariables>(MeetingsDatedDocument, options);
        }
export type MeetingsDatedQueryHookResult = ReturnType<typeof useMeetingsDatedQuery>;
export type MeetingsDatedLazyQueryHookResult = ReturnType<typeof useMeetingsDatedLazyQuery>;
export type MeetingsDatedQueryResult = Apollo.QueryResult<MeetingsDatedQuery, MeetingsDatedQueryVariables>;
export const RaceDocument = gql`
    query race($id: ID, $silksSize: Int!) {
  race(id: $id) {
    id
    number
    name
    distance
    startTime
    class
    status
    prizeMoney
    trackCondition
    weather
    surfaceType
    meeting {
      id
      type
      externalIDs(sources: ["gbs"]) {
        id
        source
      }
      track {
        id
        country
        name
        state
      }
    }
    priceSets(sources: []) {
      source
      raceNumber
      type
      poolSize
      prices {
        source
        tabNo
        price
        type
      }
    }
    results(sources: []) {
      source
      positions {
        tabNo
        position
        margin
      }
      dividends {
        dividendNumbers
        dividend
        type
        poolSize
      }
    }
    competitors {
      tabNo
      barrier
      name
      scratched
      silksURL(size: $silksSize)
      prices(sources: []) {
        price
        type
        tabNo
        source
      }
      flucs(source: "OP", priceType: WIN_FIXED_ODDS) {
        price
        time
      }
    }
  }
}
    `;

/**
 * __useRaceQuery__
 *
 * To run a query within a React component, call `useRaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      silksSize: // value for 'silksSize'
 *   },
 * });
 */
export function useRaceQuery(baseOptions: Apollo.QueryHookOptions<RaceQuery, RaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RaceQuery, RaceQueryVariables>(RaceDocument, options);
      }
export function useRaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RaceQuery, RaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RaceQuery, RaceQueryVariables>(RaceDocument, options);
        }
export type RaceQueryHookResult = ReturnType<typeof useRaceQuery>;
export type RaceLazyQueryHookResult = ReturnType<typeof useRaceLazyQuery>;
export type RaceQueryResult = Apollo.QueryResult<RaceQuery, RaceQueryVariables>;
export const RaceUpdatedDocument = gql`
    subscription raceUpdated($raceId: ID) {
  raceUpdated(raceId: $raceId) {
    id
    startTime
    status
    competitors {
      scratched
      tabNo
    }
    surfaceType
  }
}
    `;

/**
 * __useRaceUpdatedSubscription__
 *
 * To run a query within a React component, call `useRaceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRaceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaceUpdatedSubscription({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function useRaceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RaceUpdatedSubscription, RaceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RaceUpdatedSubscription, RaceUpdatedSubscriptionVariables>(RaceUpdatedDocument, options);
      }
export type RaceUpdatedSubscriptionHookResult = ReturnType<typeof useRaceUpdatedSubscription>;
export type RaceUpdatedSubscriptionResult = Apollo.SubscriptionResult<RaceUpdatedSubscription>;